// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-25T19:52:28.386Z
// Property: Longbow Luxury Apartments (ID: 6767906449167469)
// Collections: 29 amenities, 6 floorplans (live), 30 photos, 52 POIs, 4 reviews, 3 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449167469",
  "property_external_id": "t0xevrb",
  "property_zillow_url": "https://www.zillow.com/apartments/mesa-az/ascend-at-longbow-highpoint/CmWqgh/",
  "property_apartments_url": "https://www.apartments.com/ascend-at-longbow-highpoint-mesa-az/t0xevrb/",
  "property_google_business_url": "https://www.google.com/maps/place/Ascend+at+Longbow+Highpoint/data=!4m2!3m1!1s0x0:0x18050bcad822bd77?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "54170470557",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "longbow-luxury-apartments",
  "property_name": "Longbow Luxury Apartments",
  "property_website_url": "https://www.liveatlongbow.com/",
  "property_domain": null,
  "property_address": "2950 N Recker Rd",
  "property_full_address": "2950 N Recker Rd, Mesa, AZ 85215",
  "property_address_1": "2950 N Recker Rd",
  "property_address_2": null,
  "property_address_city": "Mesa",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85215",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "Central Mesa",
  "property_address_latitude": "33.4683009",
  "property_address_longitude": "-111.7020438",
  "property_email": null,
  "property_phone": "(602) 691-4234",
  "property_call_tracking_phone": "844-482-7136",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Longbow Luxury Apartments in Mesa, AZ, indulge in modern living with spacious one, two, and three-bedroom floor plans. Our vibrant community features a heated resort-style pool, dog-friendly amenities, and engaging social events. Experience convenience and elegance with granite countertops, ample storage, and private patios. Your dream home awaits!",
  "property_long_description": "Welcome to Longbow Luxury Apartments, your new oasis in the heart of Mesa, AZ! Our stunning community features a variety of thoughtfully designed floor plans, including one, two, and three-bedroom apartments, perfect for every lifestyle. With a range of upscale amenities, you'll experience comfort and convenience like never before.\n\nUnwind in our heated resort-style pool, gather around the multiple fire pits, or socialize at our vibrant clubhouse. Pet lovers will appreciate our dog park and dog wash, while eco-conscious residents can take advantage of our EV charging stations and eco-friendly dual paned windows. Enjoy hassle-free living with valet trash service, on-site maintenance, and self-service package lockers, plus complimentary common area internet to keep you connected.\n\nEach apartment is a haven of elegance, featuring gourmet kitchens with granite countertops, stainless steel appliances, and soft-close cabinetry. Relax in spacious homes offering large walk-in closets, private patios or balconies, and modern finishes like hardwood-style flooring and USB-port electrical outlets. Select units even offer prep islands and pendant lighting for that extra touch of luxury.\n\nTake a stroll along the scenic trail that winds through the adjacent golf course, or join in on our fun social events that include gaming areas for added entertainment. Longbow Luxury Apartments is also a smoke-free community, ensuring a tranquil environment for all residents.\n\nFind your new home today—browse our availability or schedule a tour to visit our beautiful community. Your luxurious lifestyle awaits at Longbow Luxury Apartments!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f6b9a-e919-720e-b739-3ede5c76f3cb.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool area with lounge chairs, umbrellas, and seating, adjacent to a golf course and apartment building.",
    "public_id": "019f6b9a-e919-720e-b739-3ede5c76f3cb",
    "storage_key": "property/6767906449167469/019f6b9a-e919-720e-b739-3ede5c76f3cb.webp",
    "width": 1600,
    "height": 1066
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167469/019ffc3a-4f8e-754c-8046-2a0fd7f27b26.m4v",
  "property_featured_video_media": {
    "public_id": "019ffc3a-4f8e-754c-8046-2a0fd7f27b26",
    "storage_key": "property/6767906449167469/019ffc3a-4f8e-754c-8046-2a0fd7f27b26.m4v",
    "thumbnail_key": "property/6767906449167469/019ffc3a-4f8e-754c-8046-2a0fd7f27b26_thumb.webp",
    "size_bytes": 11074315,
    "classification": "Apartment",
    "title": "Explore Our Spacious Apartments and Modern Amenities",
    "description": "Discover comfortable living in our apartments featuring modern interiors, including living rooms and bedrooms. Enjoy community amenities like outdoor grilling areas and pet-friendly spaces."
  },
  "property_total_units": "339",
  "property_year_built": "2025",
  "property_year_renovated": null,
  "property_walk_score": "46",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.56047197640117",
  "property_admin_fee": "300",
  "property_application_fee": "70",
  "property_fees_deposit_info": "Security Deposit\n$300 -1 Month's Rent\n(refundable)",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Prohibited pets include livestock, farm animals (including potbellied pigs), and poisonous, dangerous, or exotic animals (such as snakes and spiders). Certain dog breeds are also prohibited (e.g., American Pit Bull Terrier, Rottweiler, Akita, Doberman, Wolf hybrids, etc.).",
  "property_pet_policy_description": "Pet Policy\n■\n2 Pets Per Apartment Maximum\n\n■\nDogs or Cats Welcome\n\n■\n$50/Monthly Pet Rent Per Pet\n\n■\nOne-Time $500 Pet Fee Per Pet",
  "property_petpolicy_info": "Pet Policy\n■\n2 Pets Per Apartment Maximum\n\n■\nDogs or Cats Welcome\n\n■\n$50/Monthly Pet Rent Per Pet\n\n■\nOne-Time $500 Pet Fee Per Pet",
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://portal.risebuildings.com/pm/login",
  "property_apply_now_url": "https://9234008.onlineleasing.realpage.com/#k=95594",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e190a-d6d6-71df-bb27-f845c3929ba9.webp",
  "property_primary_logo_media": {
    "alt_text": "Longbow Luxury Apartments logo",
    "public_id": "019e190a-d6d6-71df-bb27-f845c3929ba9",
    "storage_key": "property/6767906449167469/019e190a-d6d6-71df-bb27-f845c3929ba9.webp",
    "width": 1350,
    "height": 495
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e190b-3750-715c-a5ca-792ff123dde2.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e190b-3750-715c-a5ca-792ff123dde2",
    "storage_key": "property/6767906449167469/019e190b-3750-715c-a5ca-792ff123dde2.webp",
    "width": 1280,
    "height": 469
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e190b-2e20-719f-bdac-f4e82705f5fc.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e190b-2e20-719f-bdac-f4e82705f5fc",
    "storage_key": "property/6767906449167469/019e190b-2e20-719f-bdac-f4e82705f5fc.webp",
    "width": 1280,
    "height": 469
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "664 - 1,346 sq ft",
  "property_sqft_min": "664",
  "property_sqft_max": "1,346",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 32,
  "property_facebook_url": "https://www.facebook.com/ascendatlongbowhighpoint/",
  "property_instagram_url": "http://www.instagram.com/ascendatlongbowhighpoint",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJs_waclalK4cRd70i2MoLBRg",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/ascend-at-longbow-highpoint-dr-horton-mesa",
  "property_tiktok_url": "https://www.tiktok.com/@longbow_luxury_ap",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Longbow Luxury Apartments",
  "property_home_romance_title": "Find Your Dream Life at Our Cozy Apartment Community",
  "property_home_amenities_blurb": "Welcome to Longbow Luxury Apartments in sunny Mesa, AZ, where comfort meets style. Choose from one, two, or three-bedroom layouts featuring gourmet kitchens and spacious walk-in closets. Enjoy our heated resort-style pool, dog park, and vibrant clubhouse. There's a perfect home waiting for you amidst beautiful amenities!",
  "property_home_floorplans_blurb": "Welcome to Longbow Luxury Apartments in Mesa, AZ, where comfort meets style. Choose from our thoughtfully designed one, two, or three-bedroom floor plans, each tailored to suit your lifestyle. Browse our available apartment homes today and find the perfect space to call your own in this vibrant community.",
  "property_home_gallery_blurb": "At Longbow Luxury Apartments in Mesa, AZ, luxury meets lifestyle. Picture serene mornings with your pet at the dog park, sunset barbecues by the heated pool, and evenings spent by the fire pits. With modern amenities and inviting spaces, every day feels like a retreat. Your new home awaits!",
  "property_home_neighborhood_blurb": "At Longbow Luxury Apartments in Mesa, AZ, your new home is surrounded by vibrant attractions and essential services. From the scenic Red Mountain Park and Usery Mountain Regional Park to local libraries and community colleges, endless opportunities await just outside your door. Experience luxury living with nature and convenience at your fingertips!",
  "property_home_reviews_blurb": "At Longbow Luxury Apartments in Mesa, AZ, residents rave about the “exceptional amenities and friendly community atmosphere.” Experience the perfect blend of comfort and style in your new home. Curious about what else makes our community special? See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Longbow Luxury Apartments in Mesa, AZ, life thrives beyond your front door. Unwind at nearby Red Mountain Park or Usery Mountain Regional Park, dive into adventure at FUNBOX, or enjoy cultural gems like the Arizona Commemorative Air Force Museum. Embrace a vibrant lifestyle enriched by local favorites and amenities. ",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Longbow Luxury Apartments in Mesa, AZ, where upscale living meets comfort and convenience. Enjoy expansive floor plans from one to three bedrooms, complemented by resort-style amenities like a heated pool, pet-friendly spaces, and stunning golf course views. Elevate your lifestyle with modern features and vibrant community events!",
  "property_applynow_blurb": "At Longbow Luxury Apartments in Mesa, AZ, your dream home awaits! Choose from spacious one, two, or three-bedroom floor plans featuring gourmet kitchens, elegant touches, and private patios. Enjoy top-notch amenities like a heated resort-style pool, dog park, and vibrant community events. Secure your new lifestyle—lease online today!",
  "property_contactus_blurb": "At Longbow Luxury Apartments in Mesa, AZ, you'll find a diverse range of thoughtfully designed floor plans, from cozy one-bedroom retreats to spacious three-bedroom havens. Our community blends modern comfort with a welcoming atmosphere. Have questions? Contact our leasing team today for more information on your future home!",
  "property_faqs_blurb": "At Longbow Luxury Apartments in Mesa, AZ, we offer a variety of stunning floor plans, including one, two, and three-bedroom options tailored to fit your lifestyle. Curious about community amenities or pet policies? Browse our FAQs page for insightful answers to all your burning questions and elevate your apartment search!",
  "property_floorplans_blurb": "At Longbow Luxury Apartments in Mesa, AZ, we offer a variety of thoughtfully designed floor plans tailored to your lifestyle. Whether you seek the cozy charm of a one-bedroom or the spacious comfort of a three-bedroom, we have the perfect home waiting for you. Browse our available options today!",
  "property_gallery_blurb": "Welcome to Longbow Luxury Apartments in Mesa, AZ, where every detail combines elegance with comfort. Choose from spacious one, two, or three-bedroom layouts, each featuring gourmet kitchens and private balconies. Enjoy resort-style amenities like a heated pool, scenic walking trails, and a dog park. Picture yourself living here!",
  "property_interactivemap_blurb": "Welcome to Longbow Luxury Apartments in Mesa, AZ, where comfort meets elegance. Choose from one, two, or three-bedroom residences featuring gourmet kitchens, spacious walk-in closets, and private balconies. Enjoy our vibrant amenities like a heated resort-style pool, dog park, and clubhouse—all designed for your modern lifestyle.",
  "property_pets_blurb": "At Longbow Luxury Apartments in Mesa, AZ, your furry friends are part of the family! With accommodations for up to two pets, our community embraces your cats and dogs with open arms. Enjoy a lifestyle of comfort and style, while creating unforgettable moments with your beloved pets by your side.",
  "property_referafriend_blurb": "At Longbow Luxury Apartments in Mesa, AZ, your perfect home awaits! Choose from our stylish one, two, or three-bedroom floor plans designed for modern living. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy the rewards of living together amidst luxury and comfort!",
  "property_residentaccess_blurb": "At Longbow Luxury Apartments in Mesa, AZ, your ideal home awaits! Choose from beautifully designed one, two, or three-bedroom floor plans tailored for comfort. Access your resident portal effortlessly—manage rent payments, schedule maintenance, and more, all at your fingertips! Your luxury lifestyle begins here.",
  "property_reviews_blurb": "At Longbow Luxury Apartments in Mesa, AZ, residents rave about their experience: \"The community is stunning and the amenities are top-notch!\" Curious about what makes our apartments a perfect home? See what our residents have to say about living at our community and envision your future here!",
  "property_created_at": "1776896700881",
  "property_scheduletour_blurb": "At Longbow Luxury Apartments in Mesa, AZ, our thoughtfully designed floor plans cater to every lifestyle, from cozy one-bedroom nooks to spacious three-bedroom retreats. Schedule a tour today and uncover the vibrant community waiting for you. Curious about living here? Check out our residents' experiences!",
  "property_thankyou_blurb": "Thank you for reaching out to Longbow Luxury Apartments in Mesa, AZ! Your interest in our thoughtfully designed one, two, and three-bedroom floor plans is truly appreciated. Expect to hear from our team soon to help you find your perfect home among our stylish, vibrant community.",
  "property_virtualtours_blurb": "At Longbow Luxury Apartments in Mesa, AZ, you'll find thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Immerse yourself in comfort and elegance—take a virtual tour of our vibrant community and envision your next home today!",
  "property_copyright": "2026 All Rights Reserved. Longbow Luxury Apartments",
  "property_seo_title_home": "Longbow Luxury Apartments |  Apartments in Mesa, AZ",
  "property_seo_description_home": "Brand-new 1, 2 & 3 bedroom apartments in Mesa, AZ. Heated resort pool, fitness center, dog park & EV charging. By Usery Mountain Park & Red Mountain Promenade.",
  "property_seo_title_floorplans": "1, 2 & 3 Bedroom Apartments for Rent | Mesa AZ 85215",
  "property_seo_description_floorplans": "Browse 1, 2 & 3 bedroom floor plans at Longbow Luxury Apartments in Mesa. Granite countertops, walk-in closets, in-home washer/dryer & private patios available.",
  "property_seo_title_amenities": "Heated Pool, Fitness Center & Dog Park | Mesa, AZ",
  "property_seo_description_amenities": "Longbow Luxury Apartments offers a heated resort pool, 24-hr fitness center, yoga studio, spin room, dog park & dog wash, EV charging & BBQ pavilion in Mesa AZ.",
  "property_seo_title_gallery": "Apartment Photos | Longbow Luxury Apartments Mesa, AZ",
  "property_seo_description_gallery": "See photos of Longbow Luxury Apartments in Mesa, AZ — resort pool, modern interior, gourmet kitchens, dog park & Usery Mountain views. Picture yourself here!",
  "property_seo_title_virtualtours": "Virtual Tours | Longbow Luxury Apartments in Mesa, AZ",
  "property_seo_description_virtualtours": "Can't visit in person? Take a virtual tour of Longbow Luxury Apartments in Mesa, AZ and explore our 1, 2 & 3 bedroom floor plans and amenities from anywhere!",
  "property_seo_title_interactivemap": "Interactive Map | Longbow Luxury Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your oasis at Longbow Luxury Apartments in Mesa, AZ. Explore upscale floor plans and amenities with our interactive map!",
  "property_seo_title_neighborhood": "Mesa AZ Neighborhood Guide | Longbow Luxury Apartments",
  "property_seo_description_neighborhood": "Longbow Luxury Apartments is minutes from Usery Mountain Regional Park, Red Mountain Promenade, Sprouts & major employers Amazon, Boeing & Falcon Field Airport.",
  "property_seo_title_contact": "Contact Us | Longbow Luxury Apartments",
  "property_seo_description_contact": "Experience luxury living at Longbow Luxury Apartments in Mesa, AZ. Choose from 1, 2, or 3-bedroom floor plans. Have questions? Reach out to our leasing team!",
  "property_seo_title_faqs": "FAQs & Leasing Info | Longbow Luxury Apartments Mesa AZ",
  "property_seo_description_faqs": "Get answers to frequently asked questions about leasing at Longbow Luxury Apartments in Mesa, AZ — pet policy, lease terms, parking & amenities. Read our FAQs!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Mesa, AZ",
  "property_seo_description_reviews": "Experience the vibrant lifestyle at Longbow Luxury Apartments in Mesa, AZ. Read authentic resident reviews and see why they love calling our community home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Mesa, AZ",
  "property_seo_description_applynow": "Discover luxury at Longbow Luxury Apartments in Mesa, AZ! Choose from stylish 1, 2, or 3-bedroom homes with premium amenities. Apply online now!",
  "property_seo_title_residentaccess": "Resident Access | Longbow Luxury Apartments",
  "property_seo_description_residentaccess": "Welcome to Longbow Luxury Apartments in Mesa, AZ. Log in to your resident portal for easy rent payments, maintenance requests, and exclusive community updates!",
  "property_seo_title_referafriend": "Refer A Friend | Longbow Luxury Apartments",
  "property_seo_description_referafriend": "Refer a friend to Longbow Luxury Apartments in Mesa, AZ! Great friends make the best neighbors—share the luxury and lifestyle today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Longbow Luxury Apartments",
  "property_seo_description_scheduletour": "Experience the allure of Longbow Luxury Apartments in Mesa, AZ. Schedule a tour today and step into the lifestyle you've always dreamed of!",
  "property_seo_title_privacy": "Privacy Policy | Longbow Luxury Apartments Mesa, AZ",
  "property_seo_description_privacy": "Read the privacy policy for Longbow Luxury Apartments in Mesa, AZ. Learn how we collect, use, and protect your personal information on our website.",
  "property_seo_title_accessibility": "Accessibility Statement | Longbow Luxury Apartments AZ",
  "property_seo_description_accessibility": "Longbow Luxury Apartments is committed to digital accessibility in Mesa, AZ. Read our accessibility statement to learn about our WCAG 2.1 AA compliance efforts.",
  "property_seo_title_sitemap": "Sitemap | Longbow Luxury Apartments in Mesa, AZ 85215",
  "property_seo_description_sitemap": "View the full sitemap for Longbow Luxury Apartments in Mesa, AZ. Navigate to floor plans, amenities, neighborhood info, contact page & more in 85215.",
  "property_seo_title_thankyou": "Thank You | Longbow Luxury Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Longbow Luxury Apartments in Mesa, AZ! Our team will connect soon to help you find your perfect home. Stay tuned!",
  "property_seo_title_pets": "Pet-Friendly Apartments Mesa, AZ | Longbow Luxury",
  "property_seo_description_pets": "Longbow Luxury Apartments welcomes cats & dogs in Mesa, AZ. Up to 2 pets per home. Enjoy our on-site dog park & dog wash near Usery Mountain Park trails.",
  "property_updated_at": "1787669879984",
  "amenities": [
    {
      "id": "custom_79cdde98-adde-4eca-af0b-9c4596afadf7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Stylish clubhouse featuring a conference room, billiards table, and comfortable resident lounge",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_21161857-0acf-4d75-9acb-7b0a8fe51ad1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Pet-friendly community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_aefbc540-a539-4ed3-b310-938d04e0eab5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "An elegant poolside lounge featuring upscale BBQ grilling areas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_11e601d8-887a-43ce-b15a-7aaf09677bbf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "EV Charging Stations",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_5b8bcba1-eb11-445f-95eb-1e3641a0a8fd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Dedicated pet park complemented by a premium pet spa and washing station",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_62158e87-8c09-42b9-9437-32ccf32eda9b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Thoughtfully curated smoke-free living environment",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_4231498c-07ff-47b3-9422-101619f24d21",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Heated, resort-style swimming pool designed for relaxation and year-round enjoyment",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_74559704-c09b-440e-a682-2edb3c63ea55",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Multiple Fire Pits with Seating Areas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_52b1c336-8f00-4fcd-bd51-c273864f4c97",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Secure, self-service package lockers for seamless delivery management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_83595406-12d4-4695-88ad-e1df41a20362",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Complimentary high-speed Wi-Fi throughout all shared community spaces",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_5f39f3c9-5dab-43e2-abb8-7b632e86bfc3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "A resort-style Fitness Center featuring a private spin studio",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_d3468271-141d-4a10-b3d9-b9da5d90bf17",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Package Receiving",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_890721e7-b2e6-4478-acb2-e03aa47ef53d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "A scenic walking trail set along the tranquil golf course landscape",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_abb95974-b2d3-4087-890e-50fb627a2a47",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Poolside Pavilion with BBQ Grills",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_7ab98277-fef0-4e32-98e2-bca89ba7ac61",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Curated resident events and engaging social experiences, including interactive gaming and entertainment spaces",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_4c85b622-fc74-4116-a5dd-1d205a6e33e2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Premium Granite Countertops with a Timeless Look",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_38979298-c2b6-4841-9157-6cd10ff92b68",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Custom Soft-Close Cabinetry with Designer Finishes",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_160b5537-7261-47f9-8dbf-d3c430e4ed36",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Private Detached One- and Two-Car Tandem Garages",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_3091a284-239b-4435-9049-aa65f197904d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Expansive Walk-In Closets with Built-In Custom Shelving",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f27f747f-d956-4d10-8e3e-eaa5f1a9ec9f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Gourmet Prep Islands with Designer Pendant Lighting*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_9b7f1075-4bac-4203-bd49-bcb9ef5cdde5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Full-Size In-Home Washer & Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_bd3568d3-8453-48ff-acb4-25c8b2b9069d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Eco-Friendly Dual Paned Windows",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_7f64f9bd-4b0e-4da4-bc97-2771cdec8870",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Kitchen Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f28ed4f8-4949-4ee4-ab83-c0080c021ae3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "USB-Port Electrical Outlets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_fee8cf03-c359-45a0-bd42-f91f70d04b17",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "WiFi-Enabled Smart Thermostat",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a6d7ad95-545b-46a3-a70f-030131f8da5b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Chef-Inspired Gourmet Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_257fc6eb-0674-481d-87b3-508ac1edeacf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio or Balcony in Every Apartment Home",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_c906b43b-1125-49f5-9c1e-6edab68f9dcd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "Elegant Hardwood-Style Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a0c09156-0f96-4820-8f32-ce5e989a87de",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "external_id": "false",
      "title": "2-Inch Designer Wood-Style Window Blinds",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_639f2773-3c06-43fe-ba82-b8c3e7db80d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-4adf-7081-a664-b947a2fb1939.webp",
      "image_media": {
        "alt_text": "Golf course with a modern building and a flag on the green.",
        "public_id": "019f66a4-4adf-7081-a664-b947a2fb1939",
        "storage_key": "property/6767906449167469/019f66a4-4adf-7081-a664-b947a2fb1939.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Golf course with a modern building and a flag on the green.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/GSS97.jpeg"
    },
    {
      "id": "custom_9246b0c4-d500-43d2-bfdc-7c3c3d8578bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-4b8f-778b-ba4f-d948e686d8d1.webp",
      "image_media": {
        "alt_text": "Lounge area with pool table, seating, and entertainment center.",
        "public_id": "019f66a4-4b8f-778b-ba4f-d948e686d8d1",
        "storage_key": "property/6767906449167469/019f66a4-4b8f-778b-ba4f-d948e686d8d1.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Relax and unwind in the community lounge, featuring a pool table, comfortable seating, and a modern entertainment center. Perfect for socializing or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Lounge area with pool table, seating, and entertainment center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9cd-6bcd-746f-85fe-88356a594e0e.webp"
    },
    {
      "id": "custom_f8fe9ded-1f9e-40b0-8b93-783d72f4c4b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-4b61-7236-a7e4-95f114a0e5f1.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with a pool table, seating area, and bar.",
        "public_id": "019f66a4-4b61-7236-a7e4-95f114a0e5f1",
        "storage_key": "property/6767906449167469/019f66a4-4b61-7236-a7e4-95f114a0e5f1.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Enjoy leisure time in our community lounge, featuring a pool table, comfortable seating, and a modern bar area perfect for socializing.",
      "link": "",
      "alt_text": "Spacious community lounge with a pool table, seating area, and bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9cd-7fac-7318-8b76-45d41b9b5a3e.webp"
    },
    {
      "id": "custom_5abde4c3-14dd-4eb2-955d-4b5acbab99d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-4ae0-747a-bcca-9e9ff7fa9489.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a pool table, comfortable seating, and a stylish kitchen island.",
        "public_id": "019f66a4-4ae0-747a-bcca-9e9ff7fa9489",
        "storage_key": "property/6767906449167469/019f66a4-4ae0-747a-bcca-9e9ff7fa9489.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Modern lounge area with a pool table, comfortable seating, and a stylish kitchen island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9cd-9201-77b7-96d5-9a8e5297f552.webp"
    },
    {
      "id": "custom_23b9e735-5660-4cc3-89f4-e5262882e151",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-4bce-7769-a855-eb889efff291.webp",
      "image_media": {
        "alt_text": "Conference room with a large table, chairs, and a TV.",
        "public_id": "019f66a4-4bce-7769-a855-eb889efff291",
        "storage_key": "property/6767906449167469/019f66a4-4bce-7769-a855-eb889efff291.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "This modern conference room is equipped with a large table, comfortable seating, and a wall-mounted TV, perfect for meetings and presentations.",
      "link": "",
      "alt_text": "Conference room with a large table, chairs, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9cd-968b-70bb-855e-4b224bf6c2d7.webp"
    },
    {
      "id": "custom_e8fe6def-b524-4399-8109-824f2c56e2c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-4b10-70ad-95b2-58c999018f48.webp",
      "image_media": {
        "alt_text": "Covered outdoor patio with seating area and ceiling fans overlooks a grassy field.",
        "public_id": "019f66a4-4b10-70ad-95b2-58c999018f48",
        "storage_key": "property/6767906449167469/019f66a4-4b10-70ad-95b2-58c999018f48.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Enjoy the outdoors on this spacious covered patio, complete with comfortable seating and ceiling fans, offering a relaxing view of the adjacent green space.",
      "link": "",
      "alt_text": "Covered outdoor patio with seating area and ceiling fans overlooks a grassy field.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9cd-e0b1-72ad-98c3-4ae65b69bff1.webp"
    },
    {
      "id": "custom_e3d64bee-9504-4186-8be7-dc3e5e7ccfe3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-5618-71af-9d25-7b855cd8faa1.webp",
      "image_media": {
        "alt_text": "Outdoor patio with ping pong table and dining tables overlooking a golf course.",
        "public_id": "019f66a4-5618-71af-9d25-7b855cd8faa1",
        "storage_key": "property/6767906449167469/019f66a4-5618-71af-9d25-7b855cd8faa1.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Enjoy recreational activities and outdoor dining on the community patio, complete with a ping pong table and comfortable seating, all with a scenic view of the adjacent golf course.",
      "link": "",
      "alt_text": "Outdoor patio with ping pong table and dining tables overlooking a golf course.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9cd-e8c4-76de-93f5-f8e658e89791.webp"
    },
    {
      "id": "custom_89dc4a51-b928-4042-a25f-e3b7933d27ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-56d7-76af-b498-6c2737b75e79.webp",
      "image_media": {
        "alt_text": "Fitness center with Peloton bikes and TRX suspension trainers.",
        "public_id": "019f66a4-56d7-76af-b498-6c2737b75e79",
        "storage_key": "property/6767906449167469/019f66a4-56d7-76af-b498-6c2737b75e79.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Fitness center with Peloton bikes and TRX suspension trainers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9cd-dc42-7714-ab9c-bfcf6a394ff4.webp"
    },
    {
      "id": "custom_8e6bf86d-1981-47d4-a2aa-22a90787abe2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-573d-7066-a2d7-3e655892c353.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, weight machines, and a punching bag.",
        "public_id": "019f66a4-573d-7066-a2d7-3e655892c353",
        "storage_key": "property/6767906449167469/019f66a4-573d-7066-a2d7-3e655892c353.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, weight training equipment, and a boxing station for residents.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, weight machines, and a punching bag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9cd-c9a6-7579-8eb1-c5920832bbc5.webp"
    },
    {
      "id": "custom_122e73c7-5a69-470a-b689-2e1ada8c33aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-5e64-755a-ae9e-cbd9fb4848c4.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, weight machines, and punching bag.",
        "public_id": "019f66a4-5e64-755a-ae9e-cbd9fb4848c4",
        "storage_key": "property/6767906449167469/019f66a4-5e64-755a-ae9e-cbd9fb4848c4.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines, free weights, and strength training equipment. Enjoy a workout with a view through our expansive garage-style doors.",
      "link": "",
      "alt_text": "Fitness center with treadmills, weight machines, and punching bag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9cd-daa1-76ce-af29-283ffcfbfa8a.webp"
    },
    {
      "id": "custom_51829776-119d-4251-ac02-bdca6e152c8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-6260-7139-a857-4e8bcf2b9700.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with cardio machines, weight machines, and a punching bag.",
        "public_id": "019f66a4-6260-7139-a857-4e8bcf2b9700",
        "storage_key": "property/6767906449167469/019f66a4-6260-7139-a857-4e8bcf2b9700.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Modern apartment gym with cardio machines, weight machines, and a punching bag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9cd-cc70-75dc-9c44-729f58451b36.webp"
    },
    {
      "id": "custom_13ffb7ff-25fc-4358-8e17-1253ad2bec5e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-64ed-770e-96c7-60eb1ca4fba2.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019f66a4-64ed-770e-96c7-60eb1ca4fba2",
        "storage_key": "property/6767906449167469/019f66a4-64ed-770e-96c7-60eb1ca4fba2.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxation and soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9ce-a3ad-71bc-bbe1-7caf6c4fcd74.webp"
    },
    {
      "id": "custom_c8101d8a-4136-4696-83cc-3ac7452f2c45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-6602-730d-983b-399f09bf1f28.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and outdoor kitchen.",
        "public_id": "019f66a4-6602-730d-983b-399f09bf1f28",
        "storage_key": "property/6767906449167469/019f66a4-6602-730d-983b-399f09bf1f28.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool with ample lounge seating and an outdoor kitchen area, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and outdoor kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9ce-a4d1-706f-aef5-68e0c510f737.webp"
    },
    {
      "id": "custom_71ff60e9-2b04-43ed-a6bb-0f9142f1ad4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-6bd3-721b-a74e-51fa58b05efe.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen area with grills and seating.",
        "public_id": "019f66a4-6bd3-721b-a74e-51fa58b05efe",
        "storage_key": "property/6767906449167469/019f66a4-6bd3-721b-a74e-51fa58b05efe.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Enjoy cooking and dining al fresco with our modern outdoor kitchen and bar seating area, perfect for gatherings.",
      "link": "",
      "alt_text": "Outdoor kitchen area with grills and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9ce-a4c7-71ec-92f7-4288c133dd1f.webp"
    },
    {
      "id": "custom_d6517da4-bc97-4e86-84bc-ca7a8c1e4ce7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-6c62-7347-b750-733bd7f3be0e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and fire pit area with lounge chairs and umbrellas.",
        "public_id": "019f66a4-6c62-7347-b750-733bd7f3be0e",
        "storage_key": "property/6767906449167469/019f66a4-6c62-7347-b750-733bd7f3be0e.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool and relaxing fire pit lounge area, perfect for unwinding or socializing.",
      "link": "",
      "alt_text": "Outdoor swimming pool and fire pit area with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9ce-a976-70fb-ab01-223de00d1890.webp"
    },
    {
      "id": "custom_e144efec-1f60-4225-9ec3-5b1d3e1f13e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-6d94-7628-9620-86fafb6e0eeb.webp",
      "image_media": {
        "alt_text": "Modern apartment complex outdoor lounge area with pool and seating.",
        "public_id": "019f66a4-6d94-7628-9620-86fafb6e0eeb",
        "storage_key": "property/6767906449167469/019f66a4-6d94-7628-9620-86fafb6e0eeb.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Relax and unwind in the resort-style pool area, featuring comfortable lounge seating and a modern outdoor living space perfect for socializing.",
      "link": "",
      "alt_text": "Modern apartment complex outdoor lounge area with pool and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9ce-0e12-72fa-83aa-e8990c759f31.webp"
    },
    {
      "id": "custom_971dbb33-451b-4c17-9a89-a05f96832975",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-6dc8-769b-9302-3fab19ae7a60.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen and dining area with bar seating and grills.",
        "public_id": "019f66a4-6dc8-769b-9302-3fab19ae7a60",
        "storage_key": "property/6767906449167469/019f66a4-6dc8-769b-9302-3fab19ae7a60.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and entertaining in our stylish outdoor kitchen and lounge area, complete with a full bar, comfortable seating, and premium grills.",
      "link": "",
      "alt_text": "Outdoor kitchen and dining area with bar seating and grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9ce-a8ac-75ff-877a-643872870d3b.webp"
    },
    {
      "id": "custom_9dddaaeb-ceb8-40ad-bce1-e54ea7c0aef5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-6ff3-756a-a4a0-e08035e5f08b.webp",
      "image_media": {
        "alt_text": "Modern dog washing station with unique hexagonal tile pattern on walls and floor.",
        "public_id": "019f66a4-6ff3-756a-a4a0-e08035e5f08b",
        "storage_key": "property/6767906449167469/019f66a4-6ff3-756a-a4a0-e08035e5f08b.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "State-of-the-art pet grooming area featuring a stainless steel tub and contemporary design. Perfect for keeping your furry friends clean.",
      "link": "",
      "alt_text": "Modern dog washing station with unique hexagonal tile pattern on walls and floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9ce-be2d-70a1-8f63-557948774d51.webp"
    },
    {
      "id": "custom_c607e2f7-07de-4737-8ada-07d028646095",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-71b5-734c-b95c-3913c24333df.webp",
      "image_media": {
        "alt_text": "Mailroom with mailboxes and package lockers",
        "public_id": "019f66a4-71b5-734c-b95c-3913c24333df",
        "storage_key": "property/6767906449167469/019f66a4-71b5-734c-b95c-3913c24333df.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Community",
      "description": "Secure mailroom with individual mailboxes and package lockers for residents.",
      "link": "",
      "alt_text": "Mailroom with mailboxes and package lockers",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9cd-b31b-767f-b3b1-5260b3caa435.webp"
    },
    {
      "id": "custom_af0b4ae8-c1d5-4737-8581-421a1292bef5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-77a3-70ca-a266-912918dfb882.webp",
      "image_media": {
        "alt_text": "Apartment buildings overlooking a golf course green with a flag.",
        "public_id": "019f66a4-77a3-70ca-a266-912918dfb882",
        "storage_key": "property/6767906449167469/019f66a4-77a3-70ca-a266-912918dfb882.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Apartment buildings overlooking a golf course green with a flag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/GSS92.jpeg"
    },
    {
      "id": "custom_c4e5238a-a7be-4391-8be1-82b4b8be5c5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-7a5a-735a-926a-7d79689dc6ef.webp",
      "image_media": {
        "alt_text": "Modern kitchen with a granite island and three black bar stools.",
        "public_id": "019f66a4-7a5a-735a-926a-7d79689dc6ef",
        "storage_key": "property/6767906449167469/019f66a4-7a5a-735a-926a-7d79689dc6ef.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring a spacious granite island with bar seating, stainless steel appliances, and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with a granite island and three black bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9d0-cddf-738b-a030-ae902945e32f.webp"
    },
    {
      "id": "custom_2b73db0f-9d67-4b23-a336-f564942e08c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-7cb2-767a-aa55-a4b76dbfa348.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite island and stainless steel appliances.",
        "public_id": "019f66a4-7cb2-767a-aa55-a4b76dbfa348",
        "storage_key": "property/6767906449167469/019f66a4-7cb2-767a-aa55-a4b76dbfa348.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Apartment",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Modern kitchen with granite island and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9d0-ce51-73e8-9ffa-4a1baae82557.webp"
    },
    {
      "id": "custom_6aa70dd4-0cfe-4859-a5a7-74a3b6100eb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-7c1d-74ee-9d70-dad81c3f9911.webp",
      "image_media": {
        "alt_text": "Interior of a modern apartment living room and kitchen area.",
        "public_id": "019f66a4-7c1d-74ee-9d70-dad81c3f9911",
        "storage_key": "property/6767906449167469/019f66a4-7c1d-74ee-9d70-dad81c3f9911.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment featuring an open-concept living and kitchen area, perfect for entertaining and comfortable living.",
      "link": "",
      "alt_text": "Interior of a modern apartment living room and kitchen area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9d0-d13c-765c-ac0b-8eb61bd75d25.webp"
    },
    {
      "id": "custom_9308b59a-fb5b-4765-a839-ed047193625e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019dd9d0-ce21-72ac-b06e-95645a33cc2f.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with white cabinets, island with stools, and stackable washer and dryer.",
        "public_id": "019dd9d0-ce21-72ac-b06e-95645a33cc2f",
        "storage_key": "property/6767906449167469/019dd9d0-ce21-72ac-b06e-95645a33cc2f.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area and modern kitchen, featuring sleek white cabinetry, a breakfast bar with bar stools, and a convenient in-unit washer and dryer.",
      "link": "",
      "alt_text": "Living room and kitchen area with white cabinets, island with stools, and stackable washer and dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e8648ddc-d9f0-42b7-92f2-f96657886b01",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019dd9d0-d248-728f-825e-500037949292.webp",
      "image_media": {
        "alt_text": "Open-concept living room and kitchen with modern furnishings, including a sofa, coffee table, and kitchen island with bar stools.",
        "public_id": "019dd9d0-d248-728f-825e-500037949292",
        "storage_key": "property/6767906449167469/019dd9d0-d248-728f-825e-500037949292.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Apartment",
      "description": "Experience modern living in this spacious apartment, featuring a seamless flow between the stylish living area and a fully equipped kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Open-concept living room and kitchen with modern furnishings, including a sofa, coffee table, and kitchen island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b4294892-bb4f-43f5-82d4-ab6b5d6bf377",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-84fa-744f-b4af-fb4a22c70541.webp",
      "image_media": {
        "alt_text": "Bedroom with a large framed artwork above the bed and a dresser with a round mirror.",
        "public_id": "019f66a4-84fa-744f-b4af-fb4a22c70541",
        "storage_key": "property/6767906449167469/019f66a4-84fa-744f-b4af-fb4a22c70541.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a plush bed, a modern dresser, and a large abstract artwork, creating a chic and inviting atmosphere.",
      "link": "",
      "alt_text": "Bedroom with a large framed artwork above the bed and a dresser with a round mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9d0-ed11-716b-bbb0-b4b26969a1b7.webp"
    },
    {
      "id": "custom_ad84df1d-b536-4d81-8273-20bac7fbb8f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-86f8-77a8-aba0-ed77b5ff5f3c.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, barn door, and large abstract art.",
        "public_id": "019f66a4-86f8-77a8-aba0-ed77b5ff5f3c",
        "storage_key": "property/6767906449167469/019f66a4-86f8-77a8-aba0-ed77b5ff5f3c.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Apartment",
      "description": "Experience comfort in our stylish bedrooms, featuring plush bedding, contemporary decor, and ample closet space. Retreat to your personal sanctuary.",
      "link": "",
      "alt_text": "Modern bedroom with a king-size bed, barn door, and large abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9d0-f89c-7434-b927-4a2f4947cede.webp"
    },
    {
      "id": "custom_bca3d060-dbd1-4ca2-9e7b-51c0676d2050",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-8816-7138-9129-a4b09d9f5fb8.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, shower, vanity, and sink, connected to a bedroom.",
        "public_id": "019f66a4-8816-7138-9129-a4b09d9f5fb8",
        "storage_key": "property/6767906449167469/019f66a4-8816-7138-9129-a4b09d9f5fb8.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a white bathtub, spacious vanity with granite countertops, and elegant fixtures. A doorway leads to a well-appointed bedroom.",
      "link": "",
      "alt_text": "Bathroom with a bathtub, shower, vanity, and sink, connected to a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/cd54cb25/dms3rep/multi/019dd9d1-063b-7025-8907-bf5a62ea6068.webp"
    },
    {
      "id": "custom_61f582cc-3996-479c-b7e6-a5b97b79dadc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019dd9d0-ce08-766d-b0cd-ece5cd15739f.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstand, dresser, and a ceiling fan.",
        "public_id": "019dd9d0-ce08-766d-b0cd-ece5cd15739f",
        "storage_key": "property/6767906449167469/019dd9d0-ce08-766d-b0cd-ece5cd15739f.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished bedroom featuring a comfortable king-size bed, a stylish nightstand, and a modern dresser. Includes a ceiling fan for added comfort.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstand, dresser, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c629085-83ad-4950-af79-d460839fbbc9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f66a4-8f6f-73be-93b1-324d692e2d21.webp",
      "image_media": {
        "alt_text": "Modern bathroom with dual vanity, granite countertops, walk-in closet, and glass shower.",
        "public_id": "019f66a4-8f6f-73be-93b1-324d692e2d21",
        "storage_key": "property/6767906449167469/019f66a4-8f6f-73be-93b1-324d692e2d21.webp",
        "width": 1600,
        "height": 1066
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a spacious vanity with granite countertops, a walk-in closet for ample storage, and a sleek glass-enclosed shower.",
      "link": "",
      "alt_text": "Modern bathroom with dual vanity, granite countertops, walk-in closet, and glass shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_0885a4c5-b4b7-4512-a645-4644632cfb78",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Grille @ Longbow",
      "poi_type": "Restaurants",
      "poi_address": "5601 E Longbow Pkwy, Mesa, AZ 85215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-70d5-7255-833d-b4136d820237.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-70d5-7255-833d-b4136d820237",
        "storage_key": "property/6767906449167469/019e887d-70d5-7255-833d-b4136d820237.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://longbowgrille.toast.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12886545120402694797&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "grille--longbow",
      "poi_latitude": "33.4722108",
      "poi_longitude": "-111.7099899",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-807-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-4747ee876935.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized icon of a fork and knife",
        "public_id": "019db74c-e09c-7163-ac1f-4747ee876935",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-4747ee876935.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJj_nEH76lK4cRjWKl24I01rI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_d6fb0a2f-b489-4faa-a89c-e2f2fa3b9479",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Red White and Brew",
      "poi_type": "Restaurants",
      "poi_address": "6740 E McDowell Rd #102, Mesa, AZ 85215, USA",
      "poi_short_description": "Spacious restaurant serving brick-oven pizza & American favorites in a casual, bistro-like setting.",
      "poi_long_description": "Diners like this restaurant's delicious and varied menu, with many highlighting the stromboli, pizza, French onion soup, and garlic bread. They also mention the generous portions and reasonable prices, making it a great value. Guests appreciate the friendly, attentive staff and the cozy, upbeat atmosphere, including a comfortable patio with misters and heaters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-7668-75c6-a0eb-14823cdd42b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-7668-75c6-a0eb-14823cdd42b9",
        "storage_key": "property/6767906449167469/019e887d-7668-75c6-a0eb-14823cdd42b9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.rwbaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5222740941170914113&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "red-white-and-brew",
      "poi_latitude": "33.46682",
      "poi_longitude": "-111.685036",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-807-9393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-4747ee876935.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized icon of a fork and knife",
        "public_id": "019db74c-e09c-7163-ac1f-4747ee876935",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-4747ee876935.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVYookctUKocRQbNh-Dbnekg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_0f52a321-f251-44a8-bdc1-55381b8b1817",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "The Grille At Las Sendas Golf Club",
      "poi_type": "Restaurants",
      "poi_address": "7555 E Eagle Crest Dr, Mesa, AZ 85207, USA",
      "poi_short_description": "Casual, golf-club-adjacent eatery serving steak, salmon, seafood, and salads, as well as brunch.",
      "poi_long_description": "Diners say this American restaurant offers delicious prime rib, beef tenderloin, and a wedge salad, and they praise the stunning sunset views from the patio. They also highlight the friendly and helpful staff, and the inviting atmosphere with live music.\n\nSome reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-75a1-7159-9f8d-3bf4ba5de10e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-75a1-7159-9f8d-3bf4ba5de10e",
        "storage_key": "property/6767906449167469/019e887d-75a1-7159-9f8d-3bf4ba5de10e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lassendas.com/dining/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10767132611051787981&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-grille-at-las-sendas-golf-club",
      "poi_latitude": "33.4890843",
      "poi_longitude": "-111.6709741",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-396-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-4747ee876935.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized icon of a fork and knife",
        "public_id": "019db74c-e09c-7163-ac1f-4747ee876935",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-4747ee876935.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjx6bNMykK4cRzRZEIxCKbJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_bd8e2fb2-ff57-4716-a021-2a30f669d55d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Board & Batten",
      "poi_type": "Restaurants",
      "poi_address": "4012 E Palm St, Mesa, AZ 85215, USA",
      "poi_short_description": "Refined eatery with a garden spotlighting cocktails, wine & elevated seasonal offerings.",
      "poi_long_description": "Diners say this restaurant serves up delicious pork chops, burgers, and a notable cocktail menu. They also highlight the beautiful garden patio, friendly staff, and cozy atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-7195-728c-ad2d-5998779edd50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-7195-728c-ad2d-5998779edd50",
        "storage_key": "property/6767906449167469/019e887d-7195-728c-ad2d-5998779edd50.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://bbdining.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12386057141284347816&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "board--batten",
      "poi_latitude": "33.4706189",
      "poi_longitude": "-111.7420828",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-641-4148",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-4747ee876935.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized icon of a fork and knife",
        "public_id": "019db74c-e09c-7163-ac1f-4747ee876935",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-4747ee876935.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjWVxNzakK4cRqJ_xiVgd5Ks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c464237e-5d2c-412f-8eb6-54b6404f9b5c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Jalapeño Buck's",
      "poi_type": "Restaurants",
      "poi_address": "3434 N Val Vista Dr, Mesa, AZ 85213, USA",
      "poi_short_description": "Locals line up for hearty BBQ plates & burritos at this funky, walk-up joint with a covered patio.",
      "poi_long_description": "People say this BBQ and Mexican food spot offers delicious brisket, green chile burritos, and pulled pork sandwiches. They also highlight the friendly and helpful staff, as well as the quick service. Guests mention the food is well-prepared, flavorful, and offers good value.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-7330-72af-84d0-2aba17e4d6dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-7330-72af-84d0-2aba17e4d6dc",
        "storage_key": "property/6767906449167469/019e887d-7330-72af-84d0-2aba17e4d6dc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://jalapenobucks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7595813759760057700&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jalapeo-bucks",
      "poi_latitude": "33.4786453",
      "poi_longitude": "-111.75345",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-459-3050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-4747ee876935.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized icon of a fork and knife",
        "public_id": "019db74c-e09c-7163-ac1f-4747ee876935",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-4747ee876935.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDenqryOkK4cRZMWFwl7AaWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_80d08d67-5a92-47e2-8be3-40fc38e1fcb4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Pizzicata - Mesa",
      "poi_type": "Restaurants",
      "poi_address": "6210 E McKellips Rd, Mesa, AZ 85215, USA",
      "poi_short_description": "Popular Italian restaurant offering pizzas and pastas in a warm setting with a patio.",
      "poi_long_description": "People say this pizza restaurant serves delicious, authentic Italian food, including pizza, lasagna, and meatballs. They highlight the fresh ingredients, homemade pasta, and the option to watch the pizza being made. They also like the friendly staff, attentive service, and the patio with a golf course view.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-6e11-7557-98a4-9190797e9e7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-6e11-7557-98a4-9190797e9e7e",
        "storage_key": "property/6767906449167469/019e887d-6e11-7557-98a4-9190797e9e7e.webp",
        "width": 960,
        "height": 743
      },
      "poi_business_url": "http://mesa.pizzicatausa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14949136844959011377&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pizzicata---mesa",
      "poi_latitude": "33.4528854",
      "poi_longitude": "-111.6966749",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-648-1094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-4747ee876935.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized icon of a fork and knife",
        "public_id": "019db74c-e09c-7163-ac1f-4747ee876935",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-4747ee876935.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiY9rOk-lK4cRMVJ8rsEAds8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_d204dea8-e261-4a74-88ea-15e57b8fe932",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Goldwater Brewing Co. Longbow",
      "poi_type": "Restaurants",
      "poi_address": "5942 E Longbow Pkwy Unit 105, Mesa, AZ 85215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-6f4d-70bc-8cfe-6d261b9134bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-6f4d-70bc-8cfe-6d261b9134bd",
        "storage_key": "property/6767906449167469/019e887d-6f4d-70bc-8cfe-6d261b9134bd.webp",
        "width": 1280,
        "height": 716
      },
      "poi_business_url": "https://www.goldwaterbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8668421018163143168&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "goldwater-brewing-co-longbow",
      "poi_latitude": "33.4721591",
      "poi_longitude": "-111.7019447",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-590-3215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019db74c-e09c-7163-ac1f-3dda9df493d4",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO3MP3QilK4cRAOIkH_1qTHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_9346efbd-0540-49d4-914b-8e2b01f50523",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "5918 E Longbow Pkwy, Mesa, AZ 85215, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "People say this grocery store offers a wide selection of organic produce, supplements, and delicious made-to-order deli sandwiches. Visitors also highlight the clean and organized atmosphere, along with the friendly and helpful staff.\n\nSome reviews mention the staff can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-7153-718a-9388-8918c8fa81f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-7153-718a-9388-8918c8fa81f7",
        "storage_key": "property/6767906449167469/019e887d-7153-718a-9388-8918c8fa81f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sprouts.com/store/az/mesa/mesa-recker/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3694932394720028941&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "33.47366",
      "poi_longitude": "-111.70261",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-401-3870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e0e7-74c4-850f-7a7669c2151a.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019db74c-e0e7-74c4-850f-7a7669c2151a",
        "storage_key": "property/6767906449167469/019db74c-e0e7-74c4-850f-7a7669c2151a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV0mK1vykK4cRDeleuG8JRzM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_9faf39d0-3f87-4e3d-a446-151bcc4230e1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Red Mountain Gateway",
      "poi_type": "Shopping & Retail",
      "poi_address": "2031 E McKellips Rd, Mesa, AZ 85213, USA",
      "poi_short_description": "Outdoor mall offering a variety of shopping options, including a Target.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-6e13-7468-9388-5224d5cbe024.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-6e13-7468-9388-5224d5cbe024",
        "storage_key": "property/6767906449167469/019e887d-6e13-7468-9388-5224d5cbe024.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.kimcorealty.com/properties/red-mountain-gateway/118350/view",
      "poi_directions_map_url": "https://maps.google.com/?cid=15114388472974562176&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "red-mountain-gateway",
      "poi_latitude": "33.4526499",
      "poi_longitude": "-111.6829168",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 833-800-4343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e093-71ea-b417-b6ff47d2b575.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon with a smile",
        "public_id": "019db74c-e093-71ea-b417-b6ff47d2b575",
        "storage_key": "property/6767906449167469/019db74c-e093-71ea-b417-b6ff47d2b575.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVWMoozilK4cRgFPomDwYwdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_5534b9d9-1f99-4c63-8c5d-4a0069650563",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Superstition Springs Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "6555 E Southern Ave, Mesa, AZ 85206, USA",
      "poi_short_description": "Mall featuring a two-story carousel and a food court alongside a variety of familiar retailers.",
      "poi_long_description": "Visitors say this mall offers a wide variety of stores, including popular anchor stores and unique local offerings, with a diverse food court. They also highlight the clean, well-maintained common areas, ample parking, and family-friendly features like a carousel and play areas.\n\nSome reviews mention there can be vacant stores.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-6e29-7635-b09b-36f7aa7fbb26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-6e29-7635-b09b-36f7aa7fbb26",
        "storage_key": "property/6767906449167469/019e887d-6e29-7635-b09b-36f7aa7fbb26.webp",
        "width": 640,
        "height": 1280
      },
      "poi_business_url": "https://www.superstitionsprings.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=9098130514455570276&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "superstition-springs-center",
      "poi_latitude": "33.3902535",
      "poi_longitude": "-111.6902089",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-832-0212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e093-71ea-b417-b6ff47d2b575.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon with a smile",
        "public_id": "019db74c-e093-71ea-b417-b6ff47d2b575",
        "storage_key": "property/6767906449167469/019db74c-e093-71ea-b417-b6ff47d2b575.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0ZPM-7WvK4cRZCdEun8NQ34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_330a7461-8f4d-4f60-a43e-f12fc9becffc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Mesa Riverview",
      "poi_type": "Shopping & Retail",
      "poi_address": "857 N Dobson Rd, Mesa, AZ 85201, USA",
      "poi_short_description": "Open-air shopping center with big-box retailers, dining, a cinema, gaming center & bars.",
      "poi_long_description": "Visitors say this shopping center offers a wide variety of stores and restaurants, including Bass Pro Shops, Walmart, Home Depot, and a movie theater, as well as a large park with a lake, splash pad, and zip line. They like that it's clean, safe, and has plenty of parking.\n\nSome reviews mention the shopping center can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-777b-775e-9bfd-a5b69411b983.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-777b-775e-9bfd-a5b69411b983",
        "storage_key": "property/6767906449167469/019e887d-777b-775e-9bfd-a5b69411b983.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.kimcorealty.com/properties/mesa-riverview/111780/view",
      "poi_directions_map_url": "https://maps.google.com/?cid=13821391918989314891&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mesa-riverview",
      "poi_latitude": "33.4339681",
      "poi_longitude": "-111.8674427",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 833-800-4343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e093-71ea-b417-b6ff47d2b575.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon with a smile",
        "public_id": "019db74c-e093-71ea-b417-b6ff47d2b575",
        "storage_key": "property/6767906449167469/019db74c-e093-71ea-b417-b6ff47d2b575.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEcJvvKAJK4cRSwvQsLhyz78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_4998fc7d-5196-4de5-af21-b775df640fd1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Highlands Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "1143 N Ellsworth Rd, Mesa, AZ 85207, USA",
      "poi_short_description": "Neighborhood shopping mall featuring a grocery store, a gas station, and a bakery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-784e-72a6-aa12-2daf6499dfe7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-784e-72a6-aa12-2daf6499dfe7",
        "storage_key": "property/6767906449167469/019e887d-784e-72a6-aa12-2daf6499dfe7.webp",
        "width": 719,
        "height": 1280
      },
      "poi_business_url": "https://www.yelp.com/biz/the-shoppes-at-highlands-village-mesa",
      "poi_directions_map_url": "https://maps.google.com/?cid=6729011729660159204&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "highlands-village",
      "poi_latitude": "33.4356492",
      "poi_longitude": "-111.631949",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e093-71ea-b417-b6ff47d2b575.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon with a smile",
        "public_id": "019db74c-e093-71ea-b417-b6ff47d2b575",
        "storage_key": "property/6767906449167469/019db74c-e093-71ea-b417-b6ff47d2b575.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBaYP4VCxK4cR5KTUK4RAYl0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c8c965e3-3b7c-4ff1-9535-19c33b32b8d8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Village Square At Dana Park",
      "poi_type": "Shopping & Retail",
      "poi_address": "1744 S Val Vista Dr, Mesa, AZ 85204, USA",
      "poi_short_description": "Upscale outdoor mall featuring eateries and shops carrying groceries, clothing, furniture more.",
      "poi_long_description": "People say this shopping center offers a wide variety of shops and delicious dining options, including unique places and upscale retail. They also highlight the clean, well-kept atmosphere and the abundance of convenient parking. Others mention the monthly car shows and pleasant outdoor spaces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-79da-7417-bf59-98d272c5886f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-79da-7417-bf59-98d272c5886f",
        "storage_key": "property/6767906449167469/019e887d-79da-7417-bf59-98d272c5886f.webp",
        "width": 1280,
        "height": 607
      },
      "poi_business_url": "https://www.whitestonereit.com/communities/?propertyId=dana-park-mesa-az",
      "poi_directions_map_url": "https://maps.google.com/?cid=14096543839050254156&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "village-square-at-dana-park",
      "poi_latitude": "33.3831942",
      "poi_longitude": "-111.7569548",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-397-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e093-71ea-b417-b6ff47d2b575.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon with a smile",
        "public_id": "019db74c-e093-71ea-b417-b6ff47d2b575",
        "storage_key": "property/6767906449167469/019db74c-e093-71ea-b417-b6ff47d2b575.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn2iFxy2vK4cRTMdPV-_7oMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_60baa73a-27f5-4050-9299-27e1eafba1dd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Red Mountain Ranch Elementary",
      "poi_type": "Education",
      "poi_address": "6650 E Raftriver St, Mesa, AZ 85215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74e-bb9d-74cd-8f89-e7d506f61620.webp",
      "poi_featured_image_media": {
        "alt_text": "Chalkboard wall with drawings, round table and chairs, refrigerator, and cabinets in a community room.",
        "public_id": "019db74e-bb9d-74cd-8f89-e7d506f61620",
        "storage_key": "property/6767906449167469/019db74e-bb9d-74cd-8f89-e7d506f61620.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.mpsaz.org/rmre",
      "poi_directions_map_url": "https://maps.google.com/?cid=799663093162489600&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "red-mountain-ranch-elementary",
      "poi_latitude": "33.4832398",
      "poi_longitude": "-111.6854728",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-472-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e0ec-724f-8f5a-68ece9533d5f.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019db74c-e0ec-724f-8f5a-68ece9533d5f",
        "storage_key": "property/6767906449167469/019db74c-e0ec-724f-8f5a-68ece9533d5f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXYAmgemkK4cRALfwr1j5GAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_90e50891-fbfa-4ac8-9d86-a68ada3cf098",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Red Mountain High School",
      "poi_type": "Education",
      "poi_address": "7301 E Brown Rd, Mesa, AZ 85207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74e-be66-7393-8fa4-be29f2f68046.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a large brick building with a parking lot in front.",
        "public_id": "019db74e-be66-7393-8fa4-be29f2f68046",
        "storage_key": "property/6767906449167469/019db74e-be66-7393-8fa4-be29f2f68046.webp",
        "width": 3072,
        "height": 1493
      },
      "poi_business_url": "https://rmhs.mpsaz.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15823266865284342010&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "red-mountain-high-school",
      "poi_latitude": "33.4353912",
      "poi_longitude": "-111.6738045",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-472-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e0ec-724f-8f5a-68ece9533d5f.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019db74c-e0ec-724f-8f5a-68ece9533d5f",
        "storage_key": "property/6767906449167469/019db74c-e0ec-724f-8f5a-68ece9533d5f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJr8o9xlalK4cR-mB782CJl9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_afc787ce-0d5d-48f4-b76f-31dfff73b6b1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Shepherd Junior High School",
      "poi_type": "Education",
      "poi_address": "1407 N Alta Mesa Dr, Mesa, AZ 85205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-7afb-76b9-87f0-f1a2cd7d8399.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-7afb-76b9-87f0-f1a2cd7d8399",
        "storage_key": "property/6767906449167469/019e887d-7afb-76b9-87f0-f1a2cd7d8399.webp",
        "width": 979,
        "height": 387
      },
      "poi_business_url": "https://www.mpsaz.org/shepherd",
      "poi_directions_map_url": "https://maps.google.com/?cid=2821861855759274469&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "shepherd-junior-high-school",
      "poi_latitude": "33.4406027",
      "poi_longitude": "-111.7061304",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-472-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e0ec-724f-8f5a-68ece9533d5f.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019db74c-e0ec-724f-8f5a-68ece9533d5f",
        "storage_key": "property/6767906449167469/019db74c-e0ec-724f-8f5a-68ece9533d5f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiYWCOXGlK4cR5ZHBLWhEKSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_95527dd0-a8e0-443b-a830-91fb7bea5b58",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Mesa Community College - Red Mountain Campus",
      "poi_type": "Education",
      "poi_address": "7110 E McKellips Rd, Mesa, AZ 85207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-7e3a-768b-8f8a-c372c52401d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-7e3a-768b-8f8a-c372c52401d1",
        "storage_key": "property/6767906449167469/019e887d-7e3a-768b-8f8a-c372c52401d1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mesacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4214144016360701860&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mesa-community-college---red-mountain-campus",
      "poi_latitude": "33.4552619",
      "poi_longitude": "-111.67854",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-654-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e0ec-724f-8f5a-68ece9533d5f.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019db74c-e0ec-724f-8f5a-68ece9533d5f",
        "storage_key": "property/6767906449167469/019db74c-e0ec-724f-8f5a-68ece9533d5f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa45LLDilK4cRpH-Ex6elezo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c5f26154-0235-49b7-840c-3affc90ad466",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Red Mountain Branch - Mesa Public Library",
      "poi_type": "Education",
      "poi_address": "635 N Power Rd, Mesa, AZ 85205, USA",
      "poi_short_description": "Cozy library with a selection of books, from fiction to mystery, as well as CDs, DVDs and audiobooks.",
      "poi_long_description": "People say this library offers a great selection of books, a variety of events for all ages, and a \"Think Space\" with helpful staff and equipment. Visitors also highlight the clean, spacious, and well-maintained facilities, including ample parking and a coffee stand. They consistently mention the staff are very helpful, friendly, and professional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-7c42-7443-8d06-b2a489f1c4f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-7c42-7443-8d06-b2a489f1c4f7",
        "storage_key": "property/6767906449167469/019e887d-7c42-7443-8d06-b2a489f1c4f7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mesalibrary.org/about/hours-and-locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=10682650412271200103&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "red-mountain-branch---mesa-public-library",
      "poi_latitude": "33.4275277",
      "poi_longitude": "-111.6836568",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-644-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e0ec-724f-8f5a-68ece9533d5f.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019db74c-e0ec-724f-8f5a-68ece9533d5f",
        "storage_key": "property/6767906449167469/019db74c-e0ec-724f-8f5a-68ece9533d5f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi5uvLvSvK4cRZ-caa_NlQJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_8a628c66-eda4-42f6-9d78-0cf3cbfb8b99",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Arizona State University Polytechnic Campus",
      "poi_type": "Education",
      "poi_address": "7001 E Williams Field Rd, Mesa, AZ 85212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74f-5a22-73e9-9610-2ad1496fbc1f.webp",
      "poi_featured_image_media": {
        "alt_text": "Modern building exterior at dusk with warm interior lighting and surrounding landscaping.",
        "public_id": "019db74f-5a22-73e9-9610-2ad1496fbc1f",
        "storage_key": "property/6767906449167469/019db74f-5a22-73e9-9610-2ad1496fbc1f.webp",
        "width": 1080,
        "height": 758
      },
      "poi_business_url": "http://campus.asu.edu/polytechnic",
      "poi_directions_map_url": "https://maps.google.com/?cid=3286714134695415506&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "arizona-state-university-polytechnic-campus",
      "poi_latitude": "33.3060092",
      "poi_longitude": "-111.6785238",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-727-1585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e0ec-724f-8f5a-68ece9533d5f.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019db74c-e0ec-724f-8f5a-68ece9533d5f",
        "storage_key": "property/6767906449167469/019db74c-e0ec-724f-8f5a-68ece9533d5f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-c0dQ52tK4cR0o7GfBfBnC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3d82c00b-85cb-492c-9745-533dae3ac6ab",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "AAEC - Mesa Campus",
      "poi_type": "Education",
      "poi_address": "1440 S Longmore, Mesa, AZ 85202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-81b9-7190-be5a-cc8355be4800.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-81b9-7190-be5a-cc8355be4800",
        "storage_key": "property/6767906449167469/019e887d-81b9-7190-be5a-cc8355be4800.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.aaechs.com/campuses/mesa/index",
      "poi_directions_map_url": "https://maps.google.com/?cid=15401976206392625874&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aaec---mesa-campus",
      "poi_latitude": "33.38836910000001",
      "poi_longitude": "-111.8641434",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-222-3999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e0ec-724f-8f5a-68ece9533d5f.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019db74c-e0ec-724f-8f5a-68ece9533d5f",
        "storage_key": "property/6767906449167469/019db74c-e0ec-724f-8f5a-68ece9533d5f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-bIineMHK4cR0goNrcHPvtU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_2b4d0a8b-d3ba-42b2-9d9c-c6b0bd0eaebe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "A.T. Still University",
      "poi_type": "Education",
      "poi_address": "5850 E Still Cir, Mesa, AZ 85206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-7ef3-772c-838b-82cfc74ae83e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-7ef3-772c-838b-82cfc74ae83e",
        "storage_key": "property/6767906449167469/019e887d-7ef3-772c-838b-82cfc74ae83e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.atsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7153904990256881256&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "at-still-university",
      "poi_latitude": "33.3824435",
      "poi_longitude": "-111.7049379",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-219-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e0ec-724f-8f5a-68ece9533d5f.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019db74c-e0ec-724f-8f5a-68ece9533d5f",
        "storage_key": "property/6767906449167469/019db74c-e0ec-724f-8f5a-68ece9533d5f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_____691K4cRaN4nha_GR2M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_40a37fe0-43ba-4157-941e-737b664f074c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Aviation Performance Solutions (APS)",
      "poi_type": "Education",
      "poi_address": "5649 S Avery Cir, Mesa, AZ 85212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-7f04-727c-ba38-1d319c46c6c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-7f04-727c-ba38-1d319c46c6c1",
        "storage_key": "property/6767906449167469/019e887d-7f04-727c-ba38-1d319c46c6c1.webp",
        "width": 1060,
        "height": 596
      },
      "poi_business_url": "https://apstraining.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7150301277957067428&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aviation-performance-solutions-aps",
      "poi_latitude": "33.3143857",
      "poi_longitude": "-111.6744376",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-279-1881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e0ec-724f-8f5a-68ece9533d5f.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019db74c-e0ec-724f-8f5a-68ece9533d5f",
        "storage_key": "property/6767906449167469/019db74c-e0ec-724f-8f5a-68ece9533d5f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOWUeJ4GtK4cRpBKn3SD5OmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4f7f2404-8003-4095-b93c-d97e9567db78",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "FatCats Mesa",
      "poi_type": "Entertainment",
      "poi_address": "5846 E Longbow Pkwy, Mesa, AZ 85215, USA",
      "poi_short_description": "Order food to be delivered at your seat at this modern cinema showing the latest releases.",
      "poi_long_description": "People say this movie theater offers a variety of entertainment options, including bowling, arcade games, and miniature golf, in addition to movies. They highlight the comfortable reclining seats, the clean facilities, and the fun atmosphere suitable for families and date nights. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-7f4b-7586-ac2a-6d9399373588.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-7f4b-7586-ac2a-6d9399373588",
        "storage_key": "property/6767906449167469/019e887d-7f4b-7586-ac2a-6d9399373588.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.fatcatsfun.com/mesa",
      "poi_directions_map_url": "https://maps.google.com/?cid=6969686453531935783&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fatcats-mesa",
      "poi_latitude": "33.4739656",
      "poi_longitude": "-111.7041509",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-498-3323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019db74c-e09c-7163-ac1f-3dda9df493d4",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDf96_galK4cRJ4SfCudMuWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_ea73012c-ad9e-4f37-a288-d589d50b50dc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Longbow Golf Club",
      "poi_type": "Entertainment",
      "poi_address": "5601 E Longbow Pkwy, Mesa, AZ 85215, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this golf course is well-maintained with excellent greens and a challenging yet enjoyable layout. They also highlight the friendly and helpful staff, who provide great service. Guests mention the good food and drinks available, making for a pleasant overall experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-8158-761d-b4dd-557b015ddc09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-8158-761d-b4dd-557b015ddc09",
        "storage_key": "property/6767906449167469/019e887d-8158-761d-b4dd-557b015ddc09.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.longbowgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10583502387571269862&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "longbow-golf-club",
      "poi_latitude": "33.4721336",
      "poi_longitude": "-111.7101974",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-807-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e081-721f-b67c-6164db07c912.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a person playing soccer",
        "public_id": "019db74c-e081-721f-b67c-6164db07c912",
        "storage_key": "property/6767906449167469/019db74c-e081-721f-b67c-6164db07c912.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJvVoa3v6kK4cR5iCvAlkn4JI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_45f13ba4-7c8c-465b-ad5c-4d5980e292c1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "FUNBOX Bounce & Party Center",
      "poi_type": "Entertainment",
      "poi_address": "5255 E Brown Rd, Mesa, AZ 85205, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this indoor play place features a huge bounce park with slides and obstacle courses, free arcade games, and party rooms. They also highlight the clean facility, friendly staff, and the option to bring your own food.\n\nSome reviews mention the pricing can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-9bcb-70d9-9bf1-d99fc8ac6735.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-9bcb-70d9-9bf1-d99fc8ac6735",
        "storage_key": "property/6767906449167469/019e887d-9bcb-70d9-9bf1-d99fc8ac6735.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://funbox.com/mesaaz",
      "poi_directions_map_url": "https://maps.google.com/?cid=2138762228312207059&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "funbox-bounce--party-center",
      "poi_latitude": "33.4364561",
      "poi_longitude": "-111.7167039",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-571-3255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019db74c-e09c-7163-ac1f-3dda9df493d4",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj8d_31-lK4cR026SPeporh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_9f7706e0-15cb-4b5e-a06f-d9cd615158e3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Arizona Commemorative Air Force Museum",
      "poi_type": "Entertainment",
      "poi_address": "2017 N Greenfield Rd, Mesa, AZ 85215, USA",
      "poi_short_description": "This venue with displays & rides in historic warplanes features a 1944 B-17G bomber & an F4 Phantom.",
      "poi_long_description": "People say this museum offers a vast collection of aircraft, including many airworthy WWII planes, and a piece of the USS Arizona. They highlight the knowledgeable staff, the opportunity to take paid rides in some of the planes, and the immersive experience, especially during less crowded times. They also like the free guided tours and the theater room with video clips of planes in action.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-211b-7105-b6a1-5b935e4c1810.webp",
      "poi_featured_image_media": {
        "alt_text": "Vintage bomber plane on tarmac with sunburst behind it.",
        "public_id": "019db74c-211b-7105-b6a1-5b935e4c1810",
        "storage_key": "property/6767906449167469/019db74c-211b-7105-b6a1-5b935e4c1810.webp",
        "width": 825,
        "height": 335
      },
      "poi_business_url": "https://www.azcaf.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1323774207500406438&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "arizona-commemorative-air-force-museum",
      "poi_latitude": "33.452532",
      "poi_longitude": "-111.73488",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-924-1940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e083-76cd-8dd7-1b21518b2a3e.webp",
      "poi_map_icon_media": {
        "alt_text": "Logo icon with M inside building outline",
        "public_id": "019db74c-e083-76cd-8dd7-1b21518b2a3e",
        "storage_key": "property/6767906449167469/019db74c-e083-76cd-8dd7-1b21518b2a3e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJrTWhPbilK4cRps7iyKD9XhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_28f984ed-8a88-4583-8abb-f2cfe95d8161",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Harkins Theatres Superstition Springs",
      "poi_type": "Entertainment",
      "poi_address": "6950 E Superstition Springs Blvd, Mesa, AZ 85209, USA",
      "poi_short_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_long_description": "People say this movie theater offers a wide selection of shows and times, and the popcorn smells and tastes yummy. They highlight the clean theaters, comfortable seats, and friendly staff. They also like the quick service and easy ticket and seat reservations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-84b9-7650-a093-8810b90fbe60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-84b9-7650-a093-8810b90fbe60",
        "storage_key": "property/6767906449167469/019e887d-84b9-7650-a093-8810b90fbe60.webp",
        "width": 1280,
        "height": 1006
      },
      "poi_business_url": "https://harkins.com/theatres/superstition-springs?utm_source=google_listing&utm_medium=web&utm_campaign=gmb&utm_id=local_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17409714149185425758&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "harkins-theatres-superstition-springs",
      "poi_latitude": "33.3854861",
      "poi_longitude": "-111.6812573",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-641-4603",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74f-7ab2-73f2-b5fc-67b5a23b37e4.webp",
      "poi_map_icon_media": {
        "alt_text": "Film reel icon",
        "public_id": "019db74f-7ab2-73f2-b5fc-67b5a23b37e4",
        "storage_key": "property/6767906449167469/019db74f-7ab2-73f2-b5fc-67b5a23b37e4.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5c1nUjKuK4cRXhFKL8e6m_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_922af87e-1922-4862-b438-67b91c5676f2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Arizona Museum of Natural History",
      "poi_type": "Entertainment",
      "poi_address": "53 N Macdonald, Mesa, AZ 85201, USA",
      "poi_short_description": "Southwest life & art exhibits including dinosaur displays, a Hohokam village & gold panning.",
      "poi_long_description": "People say this museum offers engaging dinosaur exhibits, including real fossils and animatronic displays, along with interactive activities like gold panning and a children's play area. Visitors highlight the reasonable entry fees and the friendly, knowledgeable staff. They also appreciate the clean restrooms and the museum's accessibility features, such as elevators and free parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-82c5-75b9-9f98-a376b71ff052.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-82c5-75b9-9f98-a376b71ff052",
        "storage_key": "property/6767906449167469/019e887d-82c5-75b9-9f98-a376b71ff052.webp",
        "width": 1280,
        "height": 662
      },
      "poi_business_url": "https://www.azmnh.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8553743256923412926&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "arizona-museum-of-natural-history",
      "poi_latitude": "33.4166023",
      "poi_longitude": "-111.8336627",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-644-2230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e083-76cd-8dd7-1b21518b2a3e.webp",
      "poi_map_icon_media": {
        "alt_text": "Logo icon with M inside building outline",
        "public_id": "019db74c-e083-76cd-8dd7-1b21518b2a3e",
        "storage_key": "property/6767906449167469/019db74c-e083-76cd-8dd7-1b21518b2a3e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJGcplxemnK4cRvhnQKCwAtXY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_691c266c-6683-4ff0-ae4b-295aae904d02",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "North Mesa Performance Chiropractic: Kyle Koenke DC",
      "poi_type": "Health and Wellness",
      "poi_address": "3514 N Power Rd 110 Bldg 2, Mesa, AZ 85215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-8596-76e1-bfbb-daa15fda9092.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-8596-76e1-bfbb-daa15fda9092",
        "storage_key": "property/6767906449167469/019e887d-8596-76e1-bfbb-daa15fda9092.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.northmesaperformancechiro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10559649646964058286&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "north-mesa-performance-chiropractic-kyle-koenke-dc",
      "poi_latitude": "33.4795993",
      "poi_longitude": "-111.6843635",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-830-7288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019db74c-e09c-7163-ac1f-3dda9df493d4",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuYjWDtykK4cRrijfD2hpi5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chiropractor"
    },
    {
      "id": "custom_636f8f07-f9a2-431c-8f09-ec5f64fcdd12",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Mountainside Fitness Mesa",
      "poi_type": "Health and Wellness",
      "poi_address": "1253 N Greenfield Rd, Mesa, AZ 85205, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this fitness center offers a full-size basketball court, a variety of classes, and a juice bar with smoothies. They highlight the clean facilities, well-maintained equipment, and the availability of a sauna, steam room, and childcare. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-87e7-740b-acce-16f5ee4fa65b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-87e7-740b-acce-16f5ee4fa65b",
        "storage_key": "property/6767906449167469/019e887d-87e7-740b-acce-16f5ee4fa65b.webp",
        "width": 1280,
        "height": 608
      },
      "poi_business_url": "https://mountainsidefitness.com/locations/mesa/?utm_source=GMB&utm_medium=Local&utm_campaign=Mesa&utm_content=WebsiteLink",
      "poi_directions_map_url": "https://maps.google.com/?cid=12771131807572916890&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mountainside-fitness-mesa",
      "poi_latitude": "33.4386111",
      "poi_longitude": "-111.735",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-889-1865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019db74c-e09c-7163-ac1f-3dda9df493d4",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_QqwpSlK4cRmnoT8rYsPLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_95009473-54a8-4f25-863b-e23cc333f82d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3426 E Baseline Rd Suite 118, Mesa, AZ 85204, USA",
      "poi_short_description": "Chain fitness center offering full-body workouts that combine cardio and strength training.",
      "poi_long_description": "People say this gym offers varied and engaging workouts designed for all fitness levels, including running, rowing, and lifting. They also highlight the amazing and encouraging coaches who keep the energy up and provide excellent guidance. Guests mention the welcoming community and the spotless equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-8b3d-761f-97f6-58a7c73688fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-8b3d-761f-97f6-58a7c73688fd",
        "storage_key": "property/6767906449167469/019e887d-8b3d-761f-97f6-58a7c73688fd.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/mesa-arizona-0020?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=13862444509381200089&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "33.3811748",
      "poi_longitude": "-111.7569857",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-350-7750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019db74c-e09c-7163-ac1f-3dda9df493d4",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn-EbjSuvK4cR2Qg7vNVLYcA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_94dc35e1-5dcf-44f8-b963-eeb99bcb6e29",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Burn Boot Camp",
      "poi_type": "Health and Wellness",
      "poi_address": "1118 N Recker Rd, Mesa, AZ 85205, USA",
      "poi_short_description": "Fitness center and training facility offering boot-camp-style classes on strength, cardio and HIIT workouts.",
      "poi_long_description": "People say this gym offers varied and challenging workouts, including strength training and cardio, with trainers who provide modifications for all fitness levels. Guests mention the staff are welcoming and knowledgeable, offering personalized guidance and support. They also highlight the strong sense of community and accountability among members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-8cf6-721a-9c26-e84282af2ce2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-8cf6-721a-9c26-e84282af2ce2",
        "storage_key": "property/6767906449167469/019e887d-8cf6-721a-9c26-e84282af2ce2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://locations.burnbootcamp.com/locations/east-mesa-az/?utm_source=gmb&utm_medium=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4501061568160341053&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "burn-boot-camp",
      "poi_latitude": "33.4360657",
      "poi_longitude": "-111.7024477",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-382-7110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019db74c-e09c-7163-ac1f-3dda9df493d4",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTZR5XKilK4cRPRxcCqb7dj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e7b21ec0-6679-46f0-8736-9da3e2690bbc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Massage Envy",
      "poi_type": "Health and Wellness",
      "poi_address": "6626 E McKellips Rd Ste #105, Mesa, AZ 85215, USA",
      "poi_short_description": "Chain spa offering massage, skin care, and total body stretch services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-8881-77ae-add5-731343c52a5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-8881-77ae-add5-731343c52a5f",
        "storage_key": "property/6767906449167469/019e887d-8881-77ae-add5-731343c52a5f.webp",
        "width": 480,
        "height": 640
      },
      "poi_business_url": "https://locations.massageenvy.com/arizona/mesa/6626-east-mckellips-rd.html?utm_source=GMB&utm_medium=useractions&utm_campaign=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=1693945248571425618&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "massage-envy",
      "poi_latitude": "33.45344010000001",
      "poi_longitude": "-111.6878371",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-889-0761",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019db74c-e09c-7163-ac1f-3dda9df493d4",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY0uDkT-lK4cRUoMPijoaghc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "massage_spa"
    },
    {
      "id": "custom_eb986855-1bb7-4270-ad8a-d28877bfae0f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Banner Heart Hospital | Mesa, AZ | Baywood Ave.",
      "poi_type": "Health and Wellness",
      "poi_address": "6750 E Baywood Ave, Mesa, AZ 85206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-88a8-76be-aeea-2cd60f2fc7ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-88a8-76be-aeea-2cd60f2fc7ae",
        "storage_key": "property/6767906449167469/019e887d-88a8-76be-aeea-2cd60f2fc7ae.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/mesa/banner-heart-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=12082948633919148856&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "banner-heart-hospital--mesa-az--baywood-ave",
      "poi_latitude": "33.4113889",
      "poi_longitude": "-111.6863573",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-854-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-402edd0cb09d.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019db74c-e09c-7163-ac1f-402edd0cb09d",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-402edd0cb09d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJv2eCS-qvK4cRONMKrMNBr6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_92261684-03d7-4b10-8708-e89e67e96925",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Red Mountain Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7745 E Brown Rd, Mesa, AZ 85207, USA",
      "poi_short_description": "Green space housing facilities for sports from baseball to volleyball, plus picnicking sites.",
      "poi_long_description": "People say this park offers a wide variety of activities, including fishing, disc golf, and multiple sports courts and fields. They also highlight the beautiful scenery, well-maintained grounds, and numerous playgrounds with shade structures. Visitors appreciate the clean restrooms and ample parking, making it a great spot for family gatherings and events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-65f9-746c-9337-9bbb9ffcb3cc.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground equipment under a blue canopy with a lake in the background.",
        "public_id": "019db74c-65f9-746c-9337-9bbb9ffcb3cc",
        "storage_key": "property/6767906449167469/019db74c-65f9-746c-9337-9bbb9ffcb3cc.webp",
        "width": 680,
        "height": 510
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4223162777976286606&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "red-mountain-park",
      "poi_latitude": "33.433682",
      "poi_longitude": "-111.6692811",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-644-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e083-76cd-8dd7-16bbf7248b22.webp",
      "poi_map_icon_media": {
        "alt_text": "Black tree icon",
        "public_id": "019db74c-e083-76cd-8dd7-16bbf7248b22",
        "storage_key": "property/6767906449167469/019db74c-e083-76cd-8dd7-16bbf7248b22.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-TxbEv-vK4cRjq3t2Suwmzo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_79963352-1fdc-42c3-ab71-e2c49d882f1f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Desert Trails Bike Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2955 N Recker Rd, Mesa, AZ 85215, USA",
      "poi_short_description": "Sizable, 35-acre bike park with scenic views, a series of rugged biking trails & some big jumps.",
      "poi_long_description": "Visitors say this bike park offers a variety of trails for all skill levels, from beginners to experienced riders, with well-maintained trails and fun jump tracks. They also highlight the beautiful Arizona sunsets, the opportunity to see wildlife, and the friendly atmosphere with hikers and bikers sharing the trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74f-2ffe-7520-a45f-0a2f7d339b4a.webp",
      "poi_featured_image_media": {
        "alt_text": "Child on a bicycle on a dirt track with wooden ramps.",
        "public_id": "019db74f-2ffe-7520-a45f-0a2f7d339b4a",
        "storage_key": "property/6767906449167469/019db74f-2ffe-7520-a45f-0a2f7d339b4a.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.mesaaz.gov/Activities-Culture/Parks-Recreation-and-Community-Facilities/Parks-Facilities/Desert-Trails-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14684800806917809455&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "desert-trails-bike-park",
      "poi_latitude": "33.4693014",
      "poi_longitude": "-111.7001029",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-644-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e083-76cd-8dd7-16bbf7248b22.webp",
      "poi_map_icon_media": {
        "alt_text": "Black tree icon",
        "public_id": "019db74c-e083-76cd-8dd7-16bbf7248b22",
        "storage_key": "property/6767906449167469/019db74c-e083-76cd-8dd7-16bbf7248b22.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQ3nTx2lK4cRL6W0zYfkyss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6031af6f-b6dd-4372-9548-2b67d33e7909",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Boulder Mountain Park At Las Sendas",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3250 N Red Mountain, Mesa, AZ 85207, USA",
      "poi_short_description": "Public park offering baseball, basketball, and tennis courts, along with a playground and a splash pad.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-915b-75bd-a331-a5375f4a2cf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-915b-75bd-a331-a5375f4a2cf2",
        "storage_key": "property/6767906449167469/019e887d-915b-75bd-a331-a5375f4a2cf2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16592474479088525843&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "boulder-mountain-park-at-las-sendas",
      "poi_latitude": "33.4755064",
      "poi_longitude": "-111.6791834",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-357-8780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e083-76cd-8dd7-16bbf7248b22.webp",
      "poi_map_icon_media": {
        "alt_text": "Black tree icon",
        "public_id": "019db74c-e083-76cd-8dd7-16bbf7248b22",
        "storage_key": "property/6767906449167469/019db74c-e083-76cd-8dd7-16bbf7248b22.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJP9JuPtikK4cRE2LOxqBPROY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6462fe53-36f8-487e-978b-ab23d95876d9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Usery Mountain Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3939 N Usery Pass Rd, Mesa, AZ 85207, USA",
      "poi_short_description": "A 3,648-acre park offering camping, archery & 29 miles of multi-use trails plus scenic wind caves.",
      "poi_long_description": "People say this park offers beautiful desert scenery and well-maintained hiking and biking trails for all skill levels. Visitors also highlight the clean restrooms and showers, along with spacious and quiet campsites. They also like the friendly staff and the variety of activities available, including archery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-8d52-7572-be8d-1f4be8ab78f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-8d52-7572-be8d-1f4be8ab78f8",
        "storage_key": "property/6767906449167469/019e887d-8d52-7572-be8d-1f4be8ab78f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.maricopacountyparks.net/park-locator/usery-mountain-regional-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9983779618521057185&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "usery-mountain-regional-park",
      "poi_latitude": "33.4791764",
      "poi_longitude": "-111.6194709",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-506-2930 ext. 4",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e083-76cd-8dd7-16bbf7248b22.webp",
      "poi_map_icon_media": {
        "alt_text": "Black tree icon",
        "public_id": "019db74c-e083-76cd-8dd7-16bbf7248b22",
        "storage_key": "property/6767906449167469/019db74c-e083-76cd-8dd7-16bbf7248b22.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9x5WzFy6K4cRoYe7raqCjYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4da38018-bcf8-4ade-bc54-ad3cb1a9828b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Salt River Tubing",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9200 N Bush Hwy, Mesa, AZ 85215, USA",
      "poi_short_description": "Popular destination for tubing on a river, with bus shuttles that pick you up at the end, plus equipment loans.",
      "poi_long_description": "People say this water sports equipment rental service offers fun rafting and tubing adventures on the Salt River, with opportunities to see wild horses and other wildlife. They highlight the efficient shuttle service, convenient tube rentals, and the relaxing and scenic float down the river. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-8ef3-74bf-aa21-b864418e18b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-8ef3-74bf-aa21-b864418e18b5",
        "storage_key": "property/6767906449167469/019e887d-8ef3-74bf-aa21-b864418e18b5.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://saltrivertubing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3046569159057507552&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "salt-river-tubing",
      "poi_latitude": "33.5452934",
      "poi_longitude": "-111.6116598",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-984-3305",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019db74c-e09c-7163-ac1f-3dda9df493d4",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHyyxP96mK4cR4IRIPYKWRyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_e1e0eadf-9913-45aa-827f-75dec11a8c88",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Saguaro Lake Guest Ranch",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13020 N Bush Hwy, Mesa, AZ 85215, USA",
      "poi_short_description": "Cozy cabins in a tranquil riverside lodge offering free breakfast, plus an outdoor pool.",
      "poi_long_description": "Cozy cabins in a tranquil riverside lodge offering free breakfast, plus an outdoor pool.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-8e38-729e-b76b-715d0685e358.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-8e38-729e-b76b-715d0685e358",
        "storage_key": "property/6767906449167469/019e887d-8e38-729e-b76b-715d0685e358.webp",
        "width": 1266,
        "height": 831
      },
      "poi_business_url": "http://www.saguarolakeranch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4102032249799053831&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "saguaro-lake-guest-ranch",
      "poi_latitude": "33.5616405",
      "poi_longitude": "-111.5359307",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-984-2194",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019db74c-e09c-7163-ac1f-3dda9df493d4",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFU_03sK-K4cRBxJ4AplY7Tg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ranch"
    },
    {
      "id": "custom_34de3f0c-cfd3-4628-9a2a-e6f0d9aca9c5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Valley Metro Mesa Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "3320 N Greenfield Rd, Mesa, AZ 85215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-919f-7281-ac95-5cc3786603e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-919f-7281-ac95-5cc3786603e7",
        "storage_key": "property/6767906449167469/019e887d-919f-7281-ac95-5cc3786603e7.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "http://www.valleymetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=265676269199101229&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "valley-metro-mesa-transit",
      "poi_latitude": "33.4756052",
      "poi_longitude": "-111.7364723",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-633-0101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019db74c-e09c-7163-ac1f-3dda9df493d4",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe1jGw0ekK4cRLQ3dwijfrwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_36bac475-2107-4078-8cd9-abbfe9774586",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Falcon Field Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "4800 E Falcon Dr, Mesa, AZ 85215, USA",
      "poi_short_description": "",
      "poi_long_description": "Visitors say this airport offers great facilities and an observation area with shade. Guests also mention it's a cool place to visit and provides an amazing experience.\n\nSome reviews mention there can be excessive flight school traffic.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-90ed-77ff-8f68-80a87e43f29d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-90ed-77ff-8f68-80a87e43f29d",
        "storage_key": "property/6767906449167469/019e887d-90ed-77ff-8f68-80a87e43f29d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.falconfieldairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15817359020008685637&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "falcon-field-airport",
      "poi_latitude": "33.4574295",
      "poi_longitude": "-111.7274145",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-644-2450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e07b-7507-8165-56d22f9dc65c.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019db74c-e07b-7507-8165-56d22f9dc65c",
        "storage_key": "property/6767906449167469/019db74c-e07b-7507-8165-56d22f9dc65c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJMXLNRLClK4cRRUBwiDmMgts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_eef195b7-664d-4546-a6ce-77549a9114ce",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Mesa Gateway Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6033 S Sossaman Rd, Mesa, AZ 85212, USA",
      "poi_short_description": "",
      "poi_long_description": "Visitors say this airport is clean, easy to navigate, and offers efficient security, making for a stress-free travel experience. They also highlight the friendly staff and convenient parking options, including a cell phone lot.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-941c-7373-832d-ece597fac9cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-941c-7373-832d-ece597fac9cc",
        "storage_key": "property/6767906449167469/019e887d-941c-7373-832d-ece597fac9cc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.gatewayairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11873809920753535279&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mesa-gateway-airport",
      "poi_latitude": "33.3089787",
      "poi_longitude": "-111.6559353",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-988-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e07b-7507-8165-56d22f9dc65c.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019db74c-e07b-7507-8165-56d22f9dc65c",
        "storage_key": "property/6767906449167469/019db74c-e07b-7507-8165-56d22f9dc65c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJz1BeVICtK4cRLwkGeTY_yKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_c78a08d6-e182-4d0a-851f-dfaf64ca921f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "The Boeing Company",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5000 E McDowell Rd, Mesa, AZ 85215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74f-4bd3-71ce-9857-60d067bca63e.webp",
      "poi_featured_image_media": {
        "alt_text": "Boeing logo on the side of a building.",
        "public_id": "019db74f-4bd3-71ce-9857-60d067bca63e",
        "storage_key": "property/6767906449167469/019db74f-4bd3-71ce-9857-60d067bca63e.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.boeing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15131330919155889974&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-boeing-company",
      "poi_latitude": "33.4727031",
      "poi_longitude": "-111.7198128",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-891-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019db74c-e09c-7163-ac1f-3dda9df493d4",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCeuKM06kK4cRNvcrP01J_dE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_05c4b815-1369-4006-af76-0ac1b9dbd077",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "MD Helicopters, LLC.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4555 E McDowell Rd, Mesa, AZ 85215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-9727-740c-aebb-2b654de053bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-9727-740c-aebb-2b654de053bf",
        "storage_key": "property/6767906449167469/019e887d-9727-740c-aebb-2b654de053bf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.mdhelicopters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16531979207802944923&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "md-helicopters-llc",
      "poi_latitude": "33.4644737",
      "poi_longitude": "-111.7289581",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-346-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019db74c-e09c-7163-ac1f-3dda9df493d4",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_1bU60ykK4cRm_08039jbeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_739f730d-0065-4e06-bd2c-dc27d5fbaf86",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Northrop Grumman",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4242 E Palm St #117, Mesa, AZ 85215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.northropgrumman.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1010153692598126635&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "northrop-grumman",
      "poi_latitude": "33.4710829",
      "poi_longitude": "-111.7384636",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-324-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019db74c-e09c-7163-ac1f-3dda9df493d4",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-fS-NDakK4cRK0jcb27JBA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_7962a47f-db74-4929-b13c-f714b5b8c346",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Nammo Defense Systems Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4051 N Higley Rd, Mesa, AZ 85215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-6dd3-72f8-825d-e4051829e8c0.webp",
      "poi_featured_image_media": {
        "alt_text": "Warning sign with an eye symbol and 'Digital Witness by Interface'.",
        "public_id": "019db74c-6dd3-72f8-825d-e4051829e8c0",
        "storage_key": "property/6767906449167469/019db74c-6dd3-72f8-825d-e4051829e8c0.webp",
        "width": 1440,
        "height": 2560
      },
      "poi_business_url": "https://www.nammo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=409469327992678063&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "nammo-defense-systems-inc",
      "poi_latitude": "33.48998520000001",
      "poi_longitude": "-111.7086086",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-898-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019db74c-e09c-7163-ac1f-3dda9df493d4",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcwDpFF6kK4cRr-ZrMS-6rgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fa5a57a1-5762-4efb-bb05-ad57440d4077",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Daicel Safety Systems Americas, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4558 E Virginia St, Mesa, AZ 85215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019e887d-98a5-73a9-9bd7-6f4fa046f999.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e887d-98a5-73a9-9bd7-6f4fa046f999",
        "storage_key": "property/6767906449167469/019e887d-98a5-73a9-9bd7-6f4fa046f999.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.daicel.com/safety/en/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1959354553397183977&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "daicel-safety-systems-americas-inc",
      "poi_latitude": "33.4783907",
      "poi_longitude": "-111.7318554",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-990-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019db74c-e09c-7163-ac1f-3dda9df493d4",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ18AJY0akK4cR6YVI0JUGMRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_d0873901-7174-472d-82eb-61c0e9a35725",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Otto Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4220 E McDowell Rd # 108, Mesa, AZ 85215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-83f6-75a1-89e8-3d5ed828b7e3.webp",
      "poi_featured_image_media": {
        "alt_text": "Two Peterbilt tow trucks parked on a road at sunset.",
        "public_id": "019db74c-83f6-75a1-89e8-3d5ed828b7e3",
        "storage_key": "property/6767906449167469/019db74c-83f6-75a1-89e8-3d5ed828b7e3.webp",
        "width": 1024,
        "height": 1536
      },
      "poi_business_url": "https://www.ottotrucking.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17240603095578896021&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "otto-headquarters",
      "poi_latitude": "33.4668818",
      "poi_longitude": "-111.739227",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-641-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon.",
        "public_id": "019db74c-e09c-7163-ac1f-3dda9df493d4",
        "storage_key": "property/6767906449167469/019db74c-e09c-7163-ac1f-3dda9df493d4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-HM53KlK4cRleZ6uSvtQu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e41ede64-596d-49ab-a4fd-8fdec64f87e0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Valley Metro Bus Stop - University & Becker",
      "poi_type": "Transportation & Transit",
      "poi_address": "University Dr & Recker Rd, Mesa, AZ 85205",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ff92095e-02bd-4323-86cf-e54ce342a77b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Valley Metro Bus Stop - Power & Melrose",
      "poi_type": "Transportation & Transit",
      "poi_address": "Power Rd & Melrose St, Mesa, AZ 85215",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ef5f8104-7d80-4c21-a7bd-afefbb0df8ed",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "custom",
      "poi_name": "Superstition Spring Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Superstition Fwy, Mesa, AZ 85206, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f153e-6a55-72dd-a9cb-524c7df66846.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f153e-6a55-72dd-a9cb-524c7df66846",
        "storage_key": "property/6767906449167469/019f153e-6a55-72dd-a9cb-524c7df66846.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=423023743751992276&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "superstition-spring-park--ride",
      "poi_latitude": "33.3873969",
      "poi_longitude": "-111.6886168",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74f-7aad-751d-ba12-b95d501ef269.webp",
      "poi_map_icon_media": {
        "alt_text": "Letter P graphic",
        "public_id": "019db74f-7aad-751d-ba12-b95d501ef269",
        "storage_key": "property/6767906449167469/019db74f-7aad-751d-ba12-b95d501ef269.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6ffZp8qvK4cR1LPkidrh3gU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    }
  ],
  "office_hours": [
    {
      "id": "ec_c3b9406935ac8c7151653154",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_80ab8b9cef4492bb20269d83",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_08b0ba82bbb55e28e1a030a4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_da54c3f3792f088fee098a00",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e686c6e0a57db55e17fbcf15",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e80fd59b48e6beeebcba6280",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_616e92c8-a84c-4488-8514-41b4873dd7fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "rating": "5.0",
      "name": "Richard Jordan",
      "text": "My daughter was touring this property and as a maintenance man myself I noticed the property was very well kept while she was tour and I was able to take a picture of the pool and noticed how beautiful it is. I ran into the service manager, Maurice and he was able to show me all the other amenities that the property had to offer. He showed me how the gym would face the golf course and how you could have a cup of coffee in the morning while watching the airplanes takeoff in the morning. I must say it was a beautiful site.",
      "date": "2026-01-03",
      "title": ""
    },
    {
      "id": "custom_02f53ae8-610d-4380-86ee-0fc660c0d2ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "rating": "5.0",
      "name": "Mark Baca III",
      "text": "These apartments are really nice. I toured the 2 bed and 2 bath model. I love how spacious they are. Lots of storage space. Lots of cabinet and counter space. There isn’t an outdoor storage closet. Lots of bedroom, bathroom, and counter space. The living room is huge! Ceilings fans are in the living room and both bedrooms. The first floor units do not have carpet.\n\nLocation is not super great, but it is really close to the U.S 60 highway. There are two EV charging connections. Overall, these apartments are awesome. I am really considering applying here!",
      "date": "2025-01-16",
      "title": ""
    },
    {
      "id": "custom_fcbc1187-0ac7-45a0-8a8a-7164be7d37a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "rating": "5.0",
      "name": "Paula Bott",
      "text": "I am continually impressed by our exceptional maintenance team here at Ascend Longbow! Maria and Guillermo are the best! They quickly responded to my call for help with getting another bed moved from the garage up two flights to my guest room. In a matter of minutes, the job was done! Thank you so much! Ascend’s community is lucky to have you both!",
      "date": "2026-01-16",
      "title": ""
    },
    {
      "id": "custom_9b7339ca-0a2b-460c-8ff5-fc9ec05f4be7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "rating": "5.0",
      "name": "Jay McClain",
      "text": "I want to give a huge thank you to Guillermo and Maria from the maintenance team at Ascend at Longbow. They are both absolutely outstanding.\n\nAny time I’ve needed something fixed, they’ve been quick to respond, professional, and genuinely kind. You can tell they take real pride in their work. Not only do they get the job done right the first time, but they also take the time to explain what they’re doing and make sure everything is working perfectly before they leave.\n\nIt’s rare to find maintenance staff who are this reliable, respectful of your home, and consistently friendly. They make living here so much better and stress-free. Ascend is lucky to have them!\n\nHighly recommend this community just based on the quality of service from Guillermo and Maria alone.",
      "date": "2026-02-02",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_43c872eda3c519a594c3f2a6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74e-7970-772d-8325-cc7685b8598d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019db74e-7970-772d-8325-cc7685b8598d",
        "storage_key": "property/6767906449167469/019db74e-7970-772d-8325-cc7685b8598d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1,099SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Et4ukn3zYvG"
    },
    {
      "id": "ec_33c45b599c630c7b0cbaf56b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74e-797d-70a7-bdf5-f9a3158d1a19.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019db74e-797d-70a7-bdf5-f9a3158d1a19",
        "storage_key": "property/6767906449167469/019db74e-797d-70a7-bdf5-f9a3158d1a19.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 664SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5hguBEY6YLs"
    },
    {
      "id": "ec_09a6febd7dbf3aed1e06c33e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019db74e-7a59-772d-991a-5f236f780132.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019db74e-7a59-772d-991a-5f236f780132",
        "storage_key": "property/6767906449167469/019db74e-7a59-772d-991a-5f236f780132.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 2BA - 1,346SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=aPKyqducoXS"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019df4d8-c01f-7578-b646-2ab59ae3eb26",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-longbow-luxury-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469"
    },
    {
      "lead_collector_id": "019ebce2-70bf-7228-bbe7-c7f1c6da3c71",
      "lead_source": "LANDING_PAGE",
      "name": "amc-longbow-luxury-apartments-lp",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-mesa-az-longbow",
      "search_query": "pet friendly apartments in mesa az",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Mesa AZ",
      "h2_subtitle": "Discover pet friendly apartments in Mesa AZ today. Longbow Luxury Apartments welcomes you and your furry friends with open arms.",
      "page_copy": "Longbow Luxury Apartments, nestled in vibrant Mesa, AZ, offers a warm invitation to pet owners seeking a harmonious living environment. Our spacious floor plans and detached garages ensure both you and your pets have plenty of room to roam. Enjoy peaceful walks along the scenic golf course trail, perfect for morning jogs with your furry companion.\n\nExperience the modern comforts of eco-friendly dual paned windows and elegant hardwood-style flooring that enhance both aesthetic appeal and convenience. We prioritize not just the comfort of our residents but also the happiness of their pets. Embrace the pet-friendly lifestyle at Longbow Luxury Apartments, where you, your family, and your pets can thrive.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Mesa AZ",
      "seo_description": "Explore pet friendly apartments in Mesa, AZ at Longbow Luxury Apartments. Enjoy ample space, scenic trails, and premium amenities for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-near-85215-longbow",
      "search_query": "apartments with in-unit laundry near 85215",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry Near 85215",
      "h2_subtitle": "Looking for apartments with in-unit laundry near 85215? Discover the convenience at Longbow Luxury Apartments in Mesa, AZ.",
      "page_copy": "Located conveniently near the 85215 area, Longbow Luxury Apartments offers the ultimate living experience with in-unit laundry facilities. Our modern apartments are designed to provide maximum comfort, featuring elegant hardwood-style flooring and eco-friendly dual paned windows that ensure a cozy and serene environment.\n\nSituated in Mesa, AZ, Longbow Luxury Apartments not only offers the ease of in-unit laundry but also provides access to wonderful amenities like a scenic trail for pet walks along the golf course. Experience the perfect blend of luxury and convenience where our stylish features meet the high demands of modern living, all in a prime location close to everything you need.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments In-Unit Laundry Near 85215",
      "seo_description": "Find apartments with in-unit laundry near 85215 at Longbow Luxury Apartments. Enjoy modern living with premium amenities in Mesa, AZ.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-maricopa-county-longbow",
      "search_query": "luxury apartments with pool in maricopa county",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Maricopa County",
      "h2_subtitle": "Searching for luxury apartments with a pool in Maricopa County? Longbow Luxury Apartments offers style, comfort, and relaxation in Mesa, AZ.",
      "page_copy": "Welcome to Longbow Luxury Apartments, where upscale living meets leisure in the heart of Maricopa County. Experience unparalleled luxury with our range of amenities, including access to a pristine pool that provides the perfect escape from the Arizona heat.\n\nOur thoughtfully designed apartments feature elegant hardwood-style flooring and modern fixtures like eco-friendly dual paned windows, ensuring a chic and comfortable atmosphere for all residents. Located in vibrant Mesa, AZ, our community offers easy access to scenic trails and other local attractions, making it an ideal retreat for those seeking both relaxation and adventure.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Maricopa",
      "seo_description": "Discover luxury apartments with a pool in Maricopa County at Longbow Luxury Apartments. Enjoy premium amenities and stylish living in Mesa, AZ.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "generator",
      "page_item_url": "dog-park-apartments-mesa-az-longbow",
      "search_query": "dog park apartments mesa az",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments Mesa AZ",
      "h2_subtitle": "Looking for dog park apartments in Mesa AZ? Longbow Luxury Apartments offers pet-friendly living and nearby dog park accessibility.",
      "page_copy": "Longbow Luxury Apartments in Mesa, AZ, caters to pet lovers looking for a community that accommodates their furry friends. Our pet-friendly environment and nearby dog park provide the perfect setting for both routine and spontaneous adventures with your dog.\n\nBeyond the dog-friendly ambiance, our apartments feature elegant hardwood-style flooring and eco-friendly dual paned windows, ensuring a comfortable lifestyle for all residents. The scenic trail along the golf course enhances the outdoor experience, making daily strolls with your canine companion a delight. Choose Longbow Luxury Apartments for a welcoming home where you and your pets can thrive.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments Mesa AZ",
      "seo_description": "Discover dog park apartments in Mesa, AZ at Longbow Luxury Apartments. Enjoy pet-friendly amenities and nearby dog park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "generator",
      "page_item_url": "resort-style-scenic-trails-mesa-az-longbow",
      "search_query": "resort-style living with scenic trails mesa arizona",
      "category": "Amenity",
      "h1_title": "Resort-Style Living with Scenic Trails Mesa, AZ",
      "h2_subtitle": "Experience resort-style living with scenic trails in Mesa, Arizona at Longbow Luxury Apartments, where nature and luxury coexist.",
      "page_copy": "At Longbow Luxury Apartments in Mesa, Arizona, we offer an unparalleled resort-style living experience surrounded by beautiful scenic trails. Perfectly integrated into our community is a picturesque trail along the golf course, providing a serene setting for walks and outdoor enjoyment.\n\nOur elegant apartments feature modern amenities such as hardwood-style flooring and eco-friendly dual paned windows, harmonizing luxury and functionality. Enjoy easy access to nature while indulging in premium comfort, making Longbow the ideal retreat for those seeking both relaxation and activity in a beautiful location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort Living with Scenic Trails in Mesa, AZ",
      "seo_description": "Enjoy resort-style living with scenic trails at Longbow Luxury Apartments in Mesa, Arizona. Luxury meets nature in this ideal setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-mesa-az-longbow",
      "search_query": "one bedroom apartments mesa az",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Mesa, AZ",
      "h2_subtitle": "Discover the perfect one bedroom apartments in Mesa, AZ at Longbow Luxury Apartments, where comfort and style meet.",
      "page_copy": "Longbow Luxury Apartments in Mesa, AZ offers beautifully designed one bedroom apartments that blend modern comfort with sophisticated style. Each unit features elegant hardwood-style flooring, eco-friendly dual paned windows, and modern 2-inch wood-style blinds, ensuring a comfortable living environment.\n\nOur residents enjoy access to unique amenities like detached tandem garages and a scenic trail along the golf course, which adds a touch of luxury to everyday life. Located in the vibrant community of Mesa, our one bedroom apartments serve as the perfect sanctuary balancing convenience and leisure.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Mesa, AZ",
      "seo_description": "Explore one bedroom apartments in Mesa, AZ at Longbow Luxury Apartments. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-maricopa-county-longbow",
      "search_query": "two bedroom apartments maricopa county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Maricopa County",
      "h2_subtitle": "Find spacious two bedroom apartments in Maricopa County at Longbow Luxury Apartments, offering amenities for comfortable living.",
      "page_copy": "At Longbow Luxury Apartments, we present two bedroom apartments in the heart of Maricopa County, designed for those who value space and modern amenities. Each apartment boasts elegant hardwood-style flooring and eco-friendly dual paned windows, creating an inviting atmosphere.\n\nOur residents appreciate features like detached 1 & 2 car tandem garages and access to a scenic trail along the golf course, providing opportunities for relaxation and recreation. Choose Longbow for a refined living experience within the thriving community of Mesa, perfect for families and professionals.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Maricopa County",
      "seo_description": "Discover two bedroom apartments in Maricopa County at Longbow Luxury Apartments. Enjoy spacious living and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-85215-longbow",
      "search_query": "three bedroom apartments near 85215",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 85215",
      "h2_subtitle": "Explore three bedroom apartments near 85215 at Longbow Luxury Apartments, offering ample space and premium amenities.",
      "page_copy": "For families or those needing extra space, Longbow Luxury Apartments offers exceptional three bedroom apartments near the 85215 area. These spacious units are designed with an eye towards luxury and comfort, featuring elegant hardwood-style flooring and modern 2-inch wood-style blinds.\n\nResidents enjoy premier amenities such as detached 1 & 2 car tandem garages and a scenic trail along the golf course, perfect for leisurely walks. Nestled in the vibrant locale of Mesa, these apartments provide the perfect balance of convenience and luxury, making it an ideal home for growing families or roommates.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 85215",
      "seo_description": "Find three bedroom apartments near 85215 at Longbow Luxury Apartments. Experience spacious living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "generator",
      "page_item_url": "apartments-near-mesa-community-college-red-mountain",
      "search_query": "apartments near mesa community college red mountain campus",
      "category": "School",
      "h1_title": "Apartments Near Mesa Community College",
      "h2_subtitle": "Discover apartments near Mesa Community College Red Mountain Campus at Longbow Luxury Apartments, where modern living meets convenience.",
      "page_copy": "Longbow Luxury Apartments offers the ideal residence for students and professionals looking for apartments near Mesa Community College Red Mountain Campus. Our apartments feature luxurious amenities such as elegant hardwood-style flooring and eco-friendly dual paned windows, creating a perfect study or work environment.\n\nConveniently located in Mesa, AZ, our community boasts amenities like detached 1 & 2 car tandem garages and a scenic trail along the golf course, providing an enriching living experience close to campus. Choose Longbow for a combination of accessibility and sophisticated living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mesa Community College Red Mountain",
      "seo_description": "Find apartments near Mesa Community College Red Mountain Campus at Longbow Luxury Apartments. Enjoy modern living and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "generator",
      "page_item_url": "luxury-apartments-near-banner-baywood-mesa",
      "search_query": "luxury apartments near Banner Baywood Medical Center Mesa AZ",
      "category": "Hospital",
      "h1_title": "Luxury Apartments Near Banner Baywood",
      "h2_subtitle": "Experience premium living at luxury apartments near Banner Baywood Medical Center in Mesa, AZ, at Longbow Luxury Apartments.",
      "page_copy": "Longbow Luxury Apartments offers an unparalleled living experience with luxury apartments located conveniently near Banner Baywood Medical Center in Mesa, AZ. Our community provides an array of upscale features, including modern 2-inch wood-style blinds and scenic views along a nearby golf course trail.\n\nResidents can enjoy detached 1 & 2 car tandem garages and elegant hardwood-style flooring, ideal for those seeking sophisticated living close to their workplace or healthcare facility. Make Longbow Luxury Apartments your new home and enjoy the perfect blend of comfort and convenience in Mesa.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments Near Banner Baywood Mesa",
      "seo_description": "Find luxury apartments near Banner Baywood Medical Center Mesa AZ at Longbow Luxury Apartments. Enjoy upscale living and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "generator",
      "page_item_url": "luxury-apartments-near-phon-d-sutton-mesa",
      "search_query": "luxury apartments near Phon D Sutton Recreation Area Mesa",
      "category": "Park",
      "h1_title": "Luxury Apartments Near Phon D Sutton",
      "h2_subtitle": "Explore luxury apartments near Phon D Sutton Recreation Area in Mesa at Longbow Luxury Apartments, combining nature and modern living.",
      "page_copy": "Discover the perfect balance between luxury living and outdoor adventure at Longbow Luxury Apartments, located near Phon D Sutton Recreation Area in Mesa. Our community brings you refined elegance with amenities such as elegant hardwood-style flooring and eco-friendly dual paned windows.\n\nWhether you enjoy a scenic walk along the golf course trail or need a spacious detached garage for your adventures, Longbow Luxury Apartments offers it all. Embrace the vibrant Mesa lifestyle with our luxury apartments that cater to both relaxation and recreation, right near the stunning Phon D Sutton Recreation Area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments Near Phon D Sutton Mesa",
      "seo_description": "Experience luxury apartments near Phon D Sutton Recreation Area Mesa at Longbow Luxury Apartments, offering premium amenities and nature access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "generator",
      "page_item_url": "longbow-apartments-near-usery-mountain-park",
      "search_query": "Longbow apartments close to Usery Mountain Regional Park AZ",
      "category": "Park",
      "h1_title": "Longbow Apartments Near Usery Mountain",
      "h2_subtitle": "Discover Longbow Apartments close to Usery Mountain Regional Park, offering luxurious living with easy access to Mesa's natural beauty.",
      "page_copy": "Nestled in the heart of Mesa, Longbow Luxury Apartments offers the perfect location for nature enthusiasts searching for an apartment close to Usery Mountain Regional Park. Our community provides the ideal retreat with features like elegant hardwood-style flooring and modern 2-inch wood-style blinds, offering a serene yet sophisticated living experience.\n\nResidents enjoy unique amenities, such as a scenic trail along the golf course and detached garages, enhancing the outdoor lifestyle experience. Choose Longbow Apartments as your home for its seamless blend of luxury and proximity to Arizona's breathtaking landscapes.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Longbow Apartments Near Usery Mountain Park",
      "seo_description": "Longbow Apartments close to Usery Mountain Regional Park AZ offer luxury living in Mesa, just minutes away from beautiful outdoor adventures.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "generator",
      "page_item_url": "luxury-living-near-granite-reef-recreational",
      "search_query": "Granite Reef Recreational Area nearby luxury living Mesa",
      "category": "Park",
      "h1_title": "Luxury Living Near Granite Reef Mesa",
      "h2_subtitle": "Find nearby luxury living in Mesa at Longbow Apartments, just minutes from Granite Reef Recreational Area's scenic views and adventures.",
      "page_copy": "Longbow Luxury Apartments provides an exquisite lifestyle option for those seeking nearby luxury living in Mesa, conveniently close to Granite Reef Recreational Area. Enjoy the comfort of elegant hardwood-style flooring and modern 2-inch wood-style blinds, perfectly paired with eco-friendly dual paned windows that fill your home with natural light.\n\nExperience the best of desert living with our detached garages and a scenic trail along the golf course, appealing to nature lovers and adventure seekers alike. Choose Longbow for a refined living experience amidst Mesa's beautiful landscapes, just steps away from the Granite Reef Recreational Area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Living Near Granite Reef Mesa",
      "seo_description": "Discover luxury living near Granite Reef Recreational Area in Mesa at Longbow Apartments, offering modern comfort and nearby natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167469",
      "source": "generator",
      "page_item_url": "luxury-apartments-near-red-mountain-park",
      "search_query": "Red Mountain Park adjacent luxury apartments Maricopa County",
      "category": "Park",
      "h1_title": "Luxury Apartments by Red Mountain Park",
      "h2_subtitle": "Explore luxury apartments in Maricopa County adjacent to Red Mountain Park, offering a blend of comfort and scenic views.",
      "page_copy": "Experience unparalleled luxury living at Longbow Luxury Apartments, situated adjacent to Red Mountain Park in Maricopa County. Our apartments offer elegantly designed interiors with features like hardwood-style flooring, modern 2-inch wood-style blinds, and eco-friendly dual paned windows.\n\nEmbrace a lifestyle of both luxury and convenience with detached garages and a scenic golf course trail right outside your door. Whether it's a leisurely stroll or an adventurous day at Red Mountain Park, Longbow Luxury Apartments cater to those who cherish both comfort and proximity to Mesa’s natural splendors.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments by Red Mountain Park",
      "seo_description": "Experience luxury at Longbow Apartments in Maricopa County, adjacent to Red Mountain Park, offering elegance and access to Mesa's natural attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11795324634"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=c0c24e126a48c26adfe85dba73a4721dcd65b53d35d262c3940eec6705d89c77fecea01e889be63e69820895d1cbebdb\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W9W3Q6SX"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "1166LNGB"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "54170470557"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/d7p1mklxpkx"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "BR573712000"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ims3ODUzVnc0QmpTbFhRUUx6aHhxckE9PSIsInZhbHVlIjoiZmJBcC9ZUHFMMTUrWU0rL21ocVpUdz09IiwibWFjIjoiNDBlMTVlN2NkMjI0NDY3MjJlNjIwMmE2YjdlNmVmYTExZDE1ZDRkOTdmODhmN2ZjYzBhOWYwYTQ0MzdjY2Y5OSJ9"
    }
  ],
  "custom_repli_id": "11795324634",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=c0c24e126a48c26adfe85dba73a4721dcd65b53d35d262c3940eec6705d89c77fecea01e889be63e69820895d1cbebdb\"></script>",
  "custom_google_gtm_id": "GTM-W9W3Q6SX",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "1166LNGB",
  "custom_hubspot_company_id": "54170470557",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/d7p1mklxpkx",
  "custom_broker_license_number": "BR573712000",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ims3ODUzVnc0QmpTbFhRUUx6aHhxckE9PSIsInZhbHVlIjoiZmJBcC9ZUHFMMTUrWU0rL21ocVpUdz09IiwibWFjIjoiNDBlMTVlN2NkMjI0NDY3MjJlNjIwMmE2YjdlNmVmYTExZDE1ZDRkOTdmODhmN2ZjYzBhOWYwYTQ0MzdjY2Y5OSJ9"
};

export const generatedAt = '2026-08-25T19:52:28.386Z';
